// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Geist+Pixel&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────────────────────
   PLATFORM FONT — SINGLE SOURCE OF TRUTH
   To change the platform font everywhere, edit the two lines below:
     1. the @import (or @font-face) that LOADS the font, and
     2. the --app-font-family value that SELECTS it.
   Every font utility (Tailwind \`font-sans\`/\`font-inter\`/\`font-nunito-sans\`/
   \`font-fontFamily\`) and the theme token (\`fontFamily\` in theme.constants.ts)
   resolve to var(--app-font-family) — so this one variable controls the whole app.
   ────────────────────────────────────────────────────────────────────────── */
/* Inter + Space Grotesk (display) — used only inside the recruiter dashboard shell (.vdash) */
/* Plus Jakarta Sans — used only inside the marketing landing page shell (.ai-landing) */
/* Geist Pixel — used only for the landing page hero title */

:root {
  --app-font-family: 'Nunito Sans', sans-serif;

  /* ── Candidate-journey design tokens (R8) ─────────────────────────────────
     Semantic, shadcn-style names so the reference (Lovable) markup ports
     near-verbatim. Everything is anchored on the brand blue (#324ECF) so the
     whole journey reads as one product. Change a value here once to restyle
     every journey screen. ──────────────────────────────────────────────── */
  --background: #ffffff;
  --foreground: #0f1729;
  --card: #ffffff;
  --card-foreground: #0f1729;
  --muted: #f1f4f9;
  --muted-foreground: #5b6577;
  --primary: #324ecf;
  --primary-foreground: #ffffff;
  --accent: #eef1fd;
  --accent-foreground: #2740a8;
  --destructive: #e5484d;
  --destructive-foreground: #ffffff;
  --border: #e4e8f0;
  --gradient-primary: linear-gradient(135deg, #324ecf 0%, #5b6ef0 100%);
  --shadow-card: 0 20px 45px -22px rgba(15, 23, 42, 0.3);
  --shadow-soft: 0 8px 24px -12px rgba(15, 23, 42, 0.14);
  /* dark surface for the camera/video preview area */
  --video-surface: oklch(0.18 0.05 265);
}

/* Marketing landing page shell — overriding --app-font-family here re-points every
   font-inter/font-sans/font-nunito-sans utility already used across the landing
   sections to Plus Jakarta Sans, without touching the rest of the app. */
.ai-landing {
  --app-font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Custom cursor replaces the native pointer on the landing page — force it off
   on every descendant so button/link \`cursor-pointer\` classes can't bring the
   native arrow back. */
@media (pointer: fine) {
  .ai-landing,
  .ai-landing * {
    cursor: none !important;
  }
}

/* Hide the scrollbar only where the landing page is mounted — scoped via
   :has() so the rest of the app (dashboard, etc.) keeps its normal scrollbar.
   The app's actual scrolling element is the shell's \`overflow-y-auto\` panel
   (see App.tsx), not <body>, but both are covered in case of other hosts. */
body:has(.ai-landing),
.overflow-y-auto:has(.ai-landing) {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* legacy Edge/IE */
}
body:has(.ai-landing)::-webkit-scrollbar,
.overflow-y-auto:has(.ai-landing)::-webkit-scrollbar {
  display: none; /* Chrome / Safari / new Edge */
}

/* Same intent, applied imperatively (see landing-page.tsx) so it doesn't
   depend on :has() support or on knowing which ancestor owns the scroll. */
html.ai-landing-scrollbar-hide,
body.ai-landing-scrollbar-hide {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* legacy Edge/IE */
}
html.ai-landing-scrollbar-hide::-webkit-scrollbar,
body.ai-landing-scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome / Safari / new Edge */
}

/* Box sizing reset */

*,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border-width: 0; /* Explicitly reset border width */
    border-style: solid; /* Ensure consistent border style */
  }

/* Basic document-level defaults */

html,
  body {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    font-family: var(--app-font-family);
  }

body {
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
  }

/* Make images easier to work with */

img,
  picture {
    max-width: 100%;
    display: block;
  }

/* Inherit fonts for inputs and buttons */

input,
  button,
  textarea,
  select {
    font: inherit;
    /* border: inherit;  */
    border-color: inherit;
    background-color: inherit;
  }

/* Remove list styles */

ul,
  ol {
    list-style: none;
  }

/* Anchor tag reset */

a {
    text-decoration: inherit;
    color: inherit;
  }

/* Only lighten existing div borders */

div,
  input,
  textarea {
    border-color: inherit; /* Prevent forcing borders on all divs */
  }

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .\\!container{
    max-width: 640px !important;
  }

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .\\!container{
    max-width: 768px !important;
  }

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .\\!container{
    max-width: 1024px !important;
  }

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .\\!container{
    max-width: 1280px !important;
  }

  .container{
    max-width: 1280px;
  }
}
.dash-skeleton {
    --skeleton-base: var(--dash-active, rgba(15, 23, 42, 0.07));
    --skeleton-shine: rgba(255, 255, 255, 0.55);
    position: relative;
    overflow: hidden;
    background: var(--skeleton-base);
    border-radius: 0.5rem;
  }
.dash-skeleton::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, var(--skeleton-shine), transparent);
    animation: dash-shimmer var(--skeleton-duration, 1.6s) ease-in-out infinite;
  }
/* The sweep lightens the surface: white on the light theme, the hover tint
     on dark (where white would flash). */
.vdash .dash-skeleton {
    --skeleton-shine: var(--dash-hover);
  }
.vdash-light .dash-skeleton {
    --skeleton-shine: rgba(255, 255, 255, 0.55);
  }
/* On a dark media surface (the video player), lighter on black. */
.dash-skeleton.dash-skeleton-inverse {
    --skeleton-base: rgba(255, 255, 255, 0.08);
    --skeleton-shine: rgba(255, 255, 255, 0.06);
  }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: -webkit-sticky;
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-1{
  inset: 0.25rem;
}
.inset-\\[22\\%\\]{
  inset: 22%;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-x-2{
  left: 0.5rem;
  right: 0.5rem;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.inset-y-0\\.5{
  top: 0.125rem;
  bottom: 0.125rem;
}
.-bottom-0{
  bottom: -0px;
}
.-bottom-0\\.5{
  bottom: -0.125rem;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-16{
  bottom: -4rem;
}
.-bottom-32{
  bottom: -8rem;
}
.-bottom-px{
  bottom: -1px;
}
.-left-1\\/2{
  left: -50%;
}
.-left-24{
  left: -6rem;
}
.-left-\\[5px\\]{
  left: -5px;
}
.-left-\\[9999px\\]{
  left: -9999px;
}
.-right-0{
  right: -0px;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-24{
  right: -6rem;
}
.-right-8{
  right: -2rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-24{
  top: -6rem;
}
.-top-4{
  top: -1rem;
}
.-top-8{
  top: -2rem;
}
.-top-\\[52px\\]{
  top: -52px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-1\\.5{
  bottom: 0.375rem;
}
.bottom-16{
  bottom: 4rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-2\\.5{
  bottom: 0.625rem;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[-20\\%\\]{
  bottom: -20%;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1\\/2{
  left: 50%;
}
.left-12{
  left: 3rem;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-6{
  left: 1.5rem;
}
.left-\\[-10\\%\\]{
  left: -10%;
}
.left-\\[18\\%\\]{
  left: 18%;
}
.left-\\[6\\%\\]{
  left: 6%;
}
.left-auto{
  left: auto;
}
.left-full{
  left: 100%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-\\[-10\\%\\]{
  right: -10%;
}
.right-\\[14\\%\\]{
  right: 14%;
}
.right-auto{
  right: auto;
}
.right-full{
  right: 100%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-7{
  top: 1.75rem;
}
.top-9{
  top: 2.25rem;
}
.top-\\[-15\\%\\]{
  top: -15%;
}
.top-\\[20\\%\\]{
  top: 20%;
}
.top-\\[24\\%\\]{
  top: 24%;
}
.top-\\[58px\\]{
  top: 58px;
}
.top-\\[6\\%\\]{
  top: 6%;
}
.top-\\[calc\\(100\\%\\+4px\\)\\]{
  top: calc(100% + 4px);
}
.top-\\[calc\\(100\\%\\+6px\\)\\]{
  top: calc(100% + 6px);
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.-z-10{
  z-index: -10;
}
.z-10{
  z-index: 10;
}
.z-100000{
  z-index: 100000;
}
.z-100002{
  z-index: 100002;
}
.z-100050{
  z-index: 100050;
}
.z-100051{
  z-index: 100051;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100000\\]{
  z-index: 100000;
}
.z-\\[100070\\]{
  z-index: 100070;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[110\\]{
  z-index: 110;
}
.z-\\[120\\]{
  z-index: 120;
}
.z-\\[1400\\]{
  z-index: 1400;
}
.z-\\[1450\\]{
  z-index: 1450;
}
.z-\\[1500\\]{
  z-index: 1500;
}
.z-\\[1600\\]{
  z-index: 1600;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[61\\]{
  z-index: 61;
}
.z-\\[70\\]{
  z-index: 70;
}
.z-\\[80\\]{
  z-index: 80;
}
.z-\\[81\\]{
  z-index: 81;
}
.z-\\[90\\]{
  z-index: 90;
}
.z-\\[91\\]{
  z-index: 91;
}
.z-\\[9990\\]{
  z-index: 9990;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.order-last{
  order: 9999;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-start-1{
  grid-column-start: 1;
}
.col-start-2{
  grid-column-start: 2;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.row-start-1{
  grid-row-start: 1;
}
.row-start-2{
  grid-row-start: 2;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-2{
  margin: 0.5rem;
}
.m-4{
  margin: 1rem;
}
.m-6{
  margin: 1.5rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-1\\.5{
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-3{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-0\\.5{
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-2\\.5{
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-0\\.5{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-\\[3px\\]{
  margin-top: 3px;
  margin-bottom: 3px;
}
.\\!mt-2{
  margin-top: 0.5rem !important;
}
.-mb-1{
  margin-bottom: -0.25rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-mr-0{
  margin-right: -0px;
}
.-mr-0\\.5{
  margin-right: -0.125rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-px{
  margin-top: -1px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-2\\.5{
  margin-left: 0.625rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[18px\\]{
  margin-top: 18px;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-\\[7px\\]{
  margin-top: 7px;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-6{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.\\!inline-block{
  display: inline-block !important;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-\\[1200\\/630\\]{
  aspect-ratio: 1200/630;
}
.aspect-\\[16\\/10\\]{
  aspect-ratio: 16/10;
}
.aspect-\\[16\\/12\\]{
  aspect-ratio: 16/12;
}
.aspect-\\[16\\/9\\]{
  aspect-ratio: 16/9;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.size-8{
  width: 2rem;
  height: 2rem;
}
.\\!h-4{
  height: 1rem !important;
}
.\\!h-8{
  height: 2rem !important;
}
.\\!h-9{
  height: 2.25rem !important;
}
.\\!h-full{
  height: 100% !important;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[11px\\]{
  height: 11px;
}
.h-\\[13px\\]{
  height: 13px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[16\\.5px\\]{
  height: 16.5px;
}
.h-\\[160px\\]{
  height: 160px;
}
.h-\\[17px\\]{
  height: 17px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[19px\\]{
  height: 19px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[21px\\]{
  height: 21px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[260px\\]{
  height: 260px;
}
.h-\\[264px\\]{
  height: 264px;
}
.h-\\[26px\\]{
  height: 26px;
}
.h-\\[26rem\\]{
  height: 26rem;
}
.h-\\[28\\%\\]{
  height: 28%;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[42\\%\\]{
  height: 42%;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[52px\\]{
  height: 52px;
}
.h-\\[55\\%\\]{
  height: 55%;
}
.h-\\[5px\\]{
  height: 5px;
}
.h-\\[60\\%\\]{
  height: 60%;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[62px\\]{
  height: 62px;
}
.h-\\[640px\\]{
  height: 640px;
}
.h-\\[66px\\]{
  height: 66px;
}
.h-\\[6px\\]{
  height: 6px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[86px\\]{
  height: 86px;
}
.h-\\[calc\\(100\\%-4px\\)\\]{
  height: calc(100% - 4px);
}
.h-auto{
  height: auto;
}
.h-dvh{
  height: 100dvh;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-\\[248px\\]{
  max-height: 248px;
}
.max-h-\\[264px\\]{
  max-height: 264px;
}
.max-h-\\[272px\\]{
  max-height: 272px;
}
.max-h-\\[280px\\]{
  max-height: 280px;
}
.max-h-\\[320px\\]{
  max-height: 320px;
}
.max-h-\\[38\\%\\]{
  max-height: 38%;
}
.max-h-\\[45vh\\]{
  max-height: 45vh;
}
.max-h-\\[52\\%\\]{
  max-height: 52%;
}
.max-h-\\[520px\\]{
  max-height: 520px;
}
.max-h-\\[62vh\\]{
  max-height: 62vh;
}
.max-h-\\[64\\%\\]{
  max-height: 64%;
}
.max-h-\\[64vh\\]{
  max-height: 64vh;
}
.max-h-\\[65vh\\]{
  max-height: 65vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[82vh\\]{
  max-height: 82vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[min\\(22rem\\2c 60vh\\)\\]{
  max-height: min(22rem,60vh);
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-10{
  min-height: 2.5rem;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[130px\\]{
  min-height: 130px;
}
.min-h-\\[180px\\]{
  min-height: 180px;
}
.min-h-\\[2\\.5rem\\]{
  min-height: 2.5rem;
}
.min-h-\\[250px\\]{
  min-height: 250px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[32px\\]{
  min-height: 32px;
}
.min-h-\\[360px\\]{
  min-height: 360px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[38px\\]{
  min-height: 38px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[440px\\]{
  min-height: 440px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[520px\\]{
  min-height: 520px;
}
.min-h-\\[540px\\]{
  min-height: 540px;
}
.min-h-\\[56px\\]{
  min-height: 56px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-4{
  width: 1rem !important;
}
.\\!w-8{
  width: 2rem !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-11\\/12{
  width: 91.666667%;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/5{
  width: 40%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-3\\/5{
  width: 60%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[104px\\]{
  width: 104px;
}
.w-\\[105px\\]{
  width: 105px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[114px\\]{
  width: 114px;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[160\\%\\]{
  width: 160%;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[168px\\]{
  width: 168px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[210px\\]{
  width: 210px;
}
.w-\\[216px\\]{
  width: 216px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[248px\\]{
  width: 248px;
}
.w-\\[26\\%\\]{
  width: 26%;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[26rem\\]{
  width: 26rem;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[330px\\]{
  width: 330px;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[36\\%\\]{
  width: 36%;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[38\\%\\]{
  width: 38%;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[42\\%\\]{
  width: 42%;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[48px\\]{
  width: 48px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[58\\%\\]{
  width: 58%;
}
.w-\\[5px\\]{
  width: 5px;
}
.w-\\[6\\%\\]{
  width: 6%;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[68px\\]{
  width: 68px;
}
.w-\\[6px\\]{
  width: 6px;
}
.w-\\[7\\%\\]{
  width: 7%;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[8\\%\\]{
  width: 8%;
}
.w-\\[85px\\]{
  width: 85px;
}
.w-\\[88px\\]{
  width: 88px;
}
.w-\\[9\\%\\]{
  width: 9%;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[calc\\(100vw-16px\\)\\]{
  width: calc(100vw - 16px);
}
.w-\\[calc\\(100vw-24px\\)\\]{
  width: calc(100vw - 24px);
}
.w-\\[calc\\(100vw-2rem\\)\\]{
  width: calc(100vw - 2rem);
}
.w-\\[calc\\(50\\%-0\\.25rem\\)\\]{
  width: calc(50% - 0.25rem);
}
.w-\\[min\\(320px\\2c 80vw\\)\\]{
  width: min(320px,80vw);
}
.w-\\[min\\(320px\\2c 90vw\\)\\]{
  width: min(320px,90vw);
}
.w-\\[min\\(380px\\2c calc\\(100vw-32px\\)\\)\\]{
  width: min(380px,calc(100vw - 32px));
}
.w-\\[min\\(440px\\2c 72\\%\\)\\]{
  width: min(440px,72%);
}
.w-\\[min\\(440px\\2c calc\\(100vw-32px\\)\\)\\]{
  width: min(440px,calc(100vw - 32px));
}
.w-\\[min\\(640px\\2c 72\\%\\)\\]{
  width: min(640px,72%);
}
.w-\\[min\\(92\\%\\2c 30rem\\)\\]{
  width: min(92%,30rem);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: -webkit-max-content;
  width: max-content;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[110px\\]{
  min-width: 110px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[132px\\]{
  min-width: 132px;
}
.min-w-\\[13px\\]{
  min-width: 13px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[168px\\]{
  min-width: 168px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[190px\\]{
  min-width: 190px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[28px\\]{
  min-width: 28px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.min-w-\\[520px\\]{
  min-width: 520px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-\\[880px\\]{
  min-width: 880px;
}
.min-w-\\[90px\\]{
  min-width: 90px;
}
.min-w-full{
  min-width: 100%;
}
.\\!max-w-4xl{
  max-width: 56rem !important;
}
.max-w-0{
  max-width: 0px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1100px\\]{
  max-width: 1100px;
}
.max-w-\\[1240px\\]{
  max-width: 1240px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[1440px\\]{
  max-width: 1440px;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[32px\\]{
  max-width: 32px;
}
.max-w-\\[340px\\]{
  max-width: 340px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[460px\\]{
  max-width: 460px;
}
.max-w-\\[50\\%\\]{
  max-width: 50%;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[55\\%\\]{
  max-width: 55%;
}
.max-w-\\[60vw\\]{
  max-width: 60vw;
}
.max-w-\\[620px\\]{
  max-width: 620px;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[680px\\]{
  max-width: 680px;
}
.max-w-\\[720px\\]{
  max-width: 720px;
}
.max-w-\\[72px\\]{
  max-width: 72px;
}
.max-w-\\[760px\\]{
  max-width: 760px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[80px\\]{
  max-width: 80px;
}
.max-w-\\[82\\%\\]{
  max-width: 82%;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[88\\%\\]{
  max-width: 88%;
}
.max-w-\\[92\\%\\]{
  max-width: 92%;
}
.max-w-\\[calc\\(100\\%-2rem\\)\\]{
  max-width: calc(100% - 2rem);
}
.max-w-\\[calc\\(100vw-1rem\\)\\]{
  max-width: calc(100vw - 1rem);
}
.max-w-\\[min\\(36rem\\2c 100\\%\\)\\]{
  max-width: min(36rem,100%);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-\\[2\\]{
  flex: 2;
}
.flex-none{
  flex: none;
}
.flex-shrink{
  flex-shrink: 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-\\[380px\\]{
  flex-basis: 380px;
}
.basis-full{
  flex-basis: 100%;
}
.table-fixed{
  table-layout: fixed;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-left{
  transform-origin: left;
}
.-translate-x-1{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2{
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2{
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2{
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[22px\\]{
  --tw-translate-x: 22px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3{
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[135deg\\]{
  --tw-rotate: 135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-skew-x-12{
  --tw-skew-x: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.01\\]{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\]{
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes fadeInUp{

  0%{
    opacity: 0;
    transform: translateY(12px);
  }

  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in-up{
  animation: fadeInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes slideInBottom{

  0%{
    transform: translateY(-100%);
  }

  100%{
    transform: translateY(0);
  }
}
.animate-slide-in-bottom{
  animation: slideInBottom 0.3s ease-out;
}
@keyframes slideInTop{

  0%{
    transform: translateY(100%);
  }

  100%{
    transform: translateY(0);
  }
}
.animate-slide-in-top{
  animation: slideInTop 0.3s ease-out;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-help{
  cursor: help;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.scroll-mt-0{
  scroll-margin-top: 0px;
}
.scroll-mt-40{
  scroll-margin-top: 10rem;
}
.scroll-mt-48{
  scroll-margin-top: 12rem;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  -webkit-appearance: none;
          appearance: none;
}
.break-inside-avoid{
  break-inside: avoid;
}
.auto-rows-\\[minmax\\(min-content\\2c 1fr\\)\\]{
  grid-auto-rows: minmax(-webkit-min-content,1fr);
  grid-auto-rows: minmax(min-content,1fr);
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[23\\]{
  grid-template-columns: 23;
}
.grid-cols-\\[260px_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 260px minmax(0,1fr);
}
.grid-cols-\\[88px_minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: 88px minmax(0,1fr) auto;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)\\2c auto\\]{
  grid-template-columns: minmax(0,1fr) auto;
}
.grid-rows-\\[0fr\\]{
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\]{
  grid-template-rows: 1fr;
}
.grid-rows-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-rows: minmax(0,1fr) minmax(0,1fr);
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.content-center{
  align-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[13px\\]{
  gap: 13px;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-\\[9px\\]{
  gap: 9px;
}
.gap-x-1{
  column-gap: 0.25rem;
}
.gap-x-12{
  column-gap: 3rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-0{
  row-gap: 0px;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-10{
  row-gap: 2.5rem;
}
.gap-y-12{
  row-gap: 3rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.gap-y-5{
  row-gap: 1.25rem;
}
.gap-y-8{
  row-gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: hsl(from var(--border) h s l / var(--tw-divide-opacity));
}
.divide-dash-border > :not([hidden]) ~ :not([hidden]){
  border-color: var(--dash-border);
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.justify-self-end{
  justify-self: end;
}
.justify-self-center{
  justify-self: center;
}
.overflow-auto{
  overflow: auto;
}
.\\!overflow-hidden{
  overflow: hidden !important;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overscroll-contain{
  overscroll-behavior: contain;
}
.overscroll-x-contain{
  overscroll-behavior-x: contain;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.\\!rounded{
  border-radius: 0.25rem !important;
}
.\\!rounded-2xl{
  border-radius: 1rem !important;
}
.\\!rounded-md{
  border-radius: 0.375rem !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-e-md{
  border-start-end-radius: 0.375rem;
  border-end-end-radius: 0.375rem;
}
.rounded-l-lg{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-none{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-\\[4px\\]{
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-s-md{
  border-start-start-radius: 0.375rem;
  border-end-start-radius: 0.375rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[3px\\]{
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.rounded-t-\\[4px\\]{
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.rounded-bl-sm{
  border-bottom-left-radius: 0.125rem;
}
.rounded-br-sm{
  border-bottom-right-radius: 0.125rem;
}
.rounded-tl-sm{
  border-top-left-radius: 0.125rem;
}
.rounded-tr-sm{
  border-top-right-radius: 0.125rem;
}
.\\!border{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-cardBorderWidth{
  border-width: var(--card-borderWidth);
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-4{
  border-bottom-width: 4px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-none{
  border-style: none !important;
}
.border-none{
  border-style: none;
}
.\\!border-dash-danger{
  border-color: var(--dash-danger) !important;
}
.\\!border-gray-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.\\!border-vjwDanger{
  --tw-border-opacity: 1 !important;
  border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.border-\\[\\#324ECF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(50 78 207 / var(--tw-border-opacity));
}
.border-\\[\\#6575FE\\]{
  --tw-border-opacity: 1;
  border-color: rgb(101 117 254 / var(--tw-border-opacity));
}
.border-\\[\\#8fa2ff\\]\\/40{
  border-color: rgb(143 162 255 / 0.4);
}
.border-\\[\\#EFEEF2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 238 242 / var(--tw-border-opacity));
}
.border-\\[var\\(--dash-accent\\)\\]{
  border-color: var(--dash-accent);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
.border-amber-400\\/40{
  border-color: rgb(251 191 36 / 0.4);
}
.border-border{
  --tw-border-opacity: 1;
  border-color: hsl(from var(--border) h s l / var(--tw-border-opacity));
}
.border-border\\/70{
  border-color: hsl(from var(--border) h s l / 0.7);
}
.border-cardBorderColor{
  border-color: var(--card-borderColor);
}
.border-dash-accent{
  border-color: var(--dash-accent);
}
.border-dash-border{
  border-color: var(--dash-border);
}
.border-dash-borderStrong{
  border-color: var(--dash-border-strong);
}
.border-dash-card{
  border-color: var(--dash-card);
}
.border-dash-danger{
  border-color: var(--dash-danger);
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: hsl(from var(--primary) h s l / var(--tw-border-opacity));
}
.border-primary\\/30{
  border-color: hsl(from var(--primary) h s l / 0.3);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-sky-400\\/30{
  border-color: rgb(56 189 248 / 0.3);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-300\\/30{
  border-color: rgb(196 181 253 / 0.3);
}
.border-violet-300\\/40{
  border-color: rgb(196 181 253 / 0.4);
}
.border-vjwDanger{
  --tw-border-opacity: 1;
  border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity));
}
.border-vjwPrimary{
  --tw-border-opacity: 1;
  border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/\\[0\\.07\\]{
  border-color: rgb(255 255 255 / 0.07);
}
.border-zinc-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.border-zinc-300\\/70{
  border-color: rgb(212 212 216 / 0.7);
}
.border-b-vjwPrimary{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.border-l-dash-accent{
  border-left-color: var(--dash-accent);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-r-dash-accent{
  border-right-color: var(--dash-accent);
}
.border-t-dash-accent{
  border-top-color: var(--dash-accent);
}
.border-t-dash-border{
  border-top-color: var(--dash-border);
}
.border-t-dash-danger{
  border-top-color: var(--dash-danger);
}
.border-t-primary{
  --tw-border-opacity: 1;
  border-top-color: hsl(from var(--primary) h s l / var(--tw-border-opacity));
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#0a0a0a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
.bg-\\[\\#0b0d18\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 13 24 / var(--tw-bg-opacity));
}
.bg-\\[\\#0b1020\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 16 32 / var(--tw-bg-opacity));
}
.bg-\\[\\#0d1020\\]\\/95{
  background-color: rgb(13 16 32 / 0.95);
}
.bg-\\[\\#11182b\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 43 / var(--tw-bg-opacity));
}
.bg-\\[\\#1e1e1e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
}
.bg-\\[\\#1e1e2e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 46 / var(--tw-bg-opacity));
}
.bg-\\[\\#324ECF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(50 78 207 / var(--tw-bg-opacity));
}
.bg-\\[\\#324ECF\\]\\/10{
  background-color: rgb(50 78 207 / 0.1);
}
.bg-\\[\\#324ecf\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(50 78 207 / var(--tw-bg-opacity));
}
.bg-\\[\\#6575FE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(101 117 254 / var(--tw-bg-opacity));
}
.bg-\\[\\#6575FE\\]\\/5{
  background-color: rgb(101 117 254 / 0.05);
}
.bg-\\[\\#6f7bff\\]\\/40{
  background-color: rgb(111 123 255 / 0.4);
}
.bg-\\[\\#9aa6ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(154 166 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#EEEBFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 235 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#EEF1FD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 241 253 / var(--tw-bg-opacity));
}
.bg-\\[\\#EFEEF2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 238 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#F3F2F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 242 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#F7F7F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#ebedfa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 237 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#ef4d7a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 77 122 / var(--tw-bg-opacity));
}
.bg-\\[\\#f6f8fc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 252 / var(--tw-bg-opacity));
}
.bg-\\[rgba\\(132\\2c 204\\2c 22\\2c 0\\.14\\)\\]{
  background-color: rgba(132,204,22,0.14);
}
.bg-\\[rgba\\(14\\2c 165\\2c 233\\2c 0\\.14\\)\\]{
  background-color: rgba(14,165,233,0.14);
}
.bg-\\[rgba\\(217\\2c 70\\2c 239\\2c 0\\.14\\)\\]{
  background-color: rgba(217,70,239,0.14);
}
.bg-\\[rgba\\(236\\2c 72\\2c 153\\2c 0\\.14\\)\\]{
  background-color: rgba(236,72,153,0.14);
}
.bg-\\[var\\(--dash-accent\\)\\]{
  background-color: var(--dash-accent);
}
.bg-accent{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--accent) h s l / var(--tw-bg-opacity));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.bg-amber-200{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/95{
  background-color: rgb(245 158 11 / 0.95);
}
.bg-background{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--background) h s l / var(--tw-bg-opacity));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55{
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85{
  background-color: rgb(0 0 0 / 0.85);
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-card{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--card) h s l / var(--tw-bg-opacity));
}
.bg-card\\/95{
  background-color: hsl(from var(--card) h s l / 0.95);
}
.bg-cardBackground{
  background-color: var(--card-backgroundColor);
}
.bg-containerBackground{
  background-color: var(--color-background);
}
.bg-current{
  background-color: currentColor;
}
.bg-dash-accent{
  background-color: var(--dash-accent);
}
.bg-dash-accentSoft{
  background-color: var(--dash-accent-soft);
}
.bg-dash-active{
  background-color: var(--dash-active);
}
.bg-dash-bg{
  background-color: var(--dash-bg);
}
.bg-dash-bg2{
  background-color: var(--dash-bg2);
}
.bg-dash-border{
  background-color: var(--dash-border);
}
.bg-dash-borderStrong{
  background-color: var(--dash-border-strong);
}
.bg-dash-card{
  background-color: var(--dash-card);
}
.bg-dash-cyanSoft{
  background-color: var(--dash-cyan-soft);
}
.bg-dash-danger{
  background-color: var(--dash-danger);
}
.bg-dash-dangerSoft{
  background-color: var(--dash-danger-soft);
}
.bg-dash-hover{
  background-color: var(--dash-hover);
}
.bg-dash-muted{
  background-color: var(--dash-muted);
}
.bg-dash-purpleSoft{
  background-color: var(--dash-purple-soft);
}
.bg-dash-success{
  background-color: var(--dash-success);
}
.bg-dash-successSoft{
  background-color: var(--dash-success-soft);
}
.bg-dash-surface{
  background-color: var(--dash-surface);
}
.bg-dash-text{
  background-color: var(--dash-text);
}
.bg-dash-warning{
  background-color: var(--dash-warning);
}
.bg-dash-warningSoft{
  background-color: var(--dash-warning-soft);
}
.bg-destructive{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--destructive) h s l / var(--tw-bg-opacity));
}
.bg-destructive\\/10{
  background-color: hsl(from var(--destructive) h s l / 0.1);
}
.bg-destructive\\/5{
  background-color: hsl(from var(--destructive) h s l / 0.05);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.bg-foreground\\/30{
  background-color: hsl(from var(--foreground) h s l / 0.3);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.bg-muted{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--muted) h s l / var(--tw-bg-opacity));
}
.bg-muted-foreground\\/40{
  background-color: hsl(from var(--muted-foreground) h s l / 0.4);
}
.bg-muted-foreground\\/60{
  background-color: hsl(from var(--muted-foreground) h s l / 0.6);
}
.bg-muted\\/30{
  background-color: hsl(from var(--muted) h s l / 0.3);
}
.bg-muted\\/40{
  background-color: hsl(from var(--muted) h s l / 0.4);
}
.bg-muted\\/50{
  background-color: hsl(from var(--muted) h s l / 0.5);
}
.bg-muted\\/60{
  background-color: hsl(from var(--muted) h s l / 0.6);
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--primary) h s l / var(--tw-bg-opacity));
}
.bg-primary\\/10{
  background-color: hsl(from var(--primary) h s l / 0.1);
}
.bg-primary\\/25{
  background-color: hsl(from var(--primary) h s l / 0.25);
}
.bg-primary\\/70{
  background-color: hsl(from var(--primary) h s l / 0.7);
}
.bg-primary\\/80{
  background-color: hsl(from var(--primary) h s l / 0.8);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-500\\/80{
  background-color: rgb(239 68 68 / 0.8);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-red-600\\/90{
  background-color: rgb(220 38 38 / 0.9);
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
.bg-sky-500\\/60{
  background-color: rgb(14 165 233 / 0.6);
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.bg-slate-200\\/80{
  background-color: rgb(226 232 240 / 0.8);
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.bg-slate-950\\/60{
  background-color: rgb(2 6 23 / 0.6);
}
.bg-slate-950\\/70{
  background-color: rgb(2 6 23 / 0.7);
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-400\\/10{
  background-color: rgb(167 139 250 / 0.1);
}
.bg-vjwDanger\\/20{
  background-color: hsl(from var(--color-danger) h s l / 0.2);
}
.bg-vjwPrimary{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
}
.bg-vjwSecondary{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/55{
  background-color: rgb(255 255 255 / 0.55);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.05\\]{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/\\[0\\.08\\]{
  background-color: rgb(255 255 255 / 0.08);
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.bg-zinc-100{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-\\[radial-gradient\\(circle_at_78\\%_85\\%\\2c rgba\\(91\\2c 110\\2c 240\\2c 0\\.22\\)\\2c transparent_50\\%\\)\\]{
  background-image: radial-gradient(circle at 78% 85%,rgba(91,110,240,0.22),transparent 50%);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-amber-400{
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/85{
  --tw-gradient-from: rgb(0 0 0 / 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-dash-accent{
  --tw-gradient-from: var(--dash-accent) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-dash-accentSoft{
  --tw-gradient-from: var(--dash-accent-soft) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-dash-danger{
  --tw-gradient-from: var(--dash-danger) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-dash-muted{
  --tw-gradient-from: var(--dash-muted) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-dash-success{
  --tw-gradient-from: var(--dash-success) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-dash-warning{
  --tw-gradient-from: var(--dash-warning) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-300{
  --tw-gradient-from: #a5b4fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(165 180 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400{
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-emerald-300{
  --tw-gradient-to: rgb(110 231 183 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6ee7b7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-400\\/\\[0\\.07\\]{
  --tw-gradient-to: rgb(129 140 248 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(129 140 248 / 0.07) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-50{
  --tw-gradient-to: rgb(248 250 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f8fafc var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-300{
  --tw-gradient-to: rgb(196 181 253 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #c4b5fd var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/25{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-dash-dangerInk{
  --tw-gradient-to: var(--dash-danger-ink) var(--tw-gradient-to-position);
}
.to-dash-purple{
  --tw-gradient-to: var(--dash-purple) var(--tw-gradient-to-position);
}
.to-dash-successInk{
  --tw-gradient-to: var(--dash-success-ink) var(--tw-gradient-to-position);
}
.to-dash-surface{
  --tw-gradient-to: var(--dash-surface) var(--tw-gradient-to-position);
}
.to-dash-text2{
  --tw-gradient-to: var(--dash-text2) var(--tw-gradient-to-position);
}
.to-dash-warningInk{
  --tw-gradient-to: var(--dash-warning-ink) var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-sky-300{
  --tw-gradient-to: #7dd3fc var(--tw-gradient-to-position);
}
.to-sky-400{
  --tw-gradient-to: #38bdf8 var(--tw-gradient-to-position);
}
.to-slate-100{
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}
.fill-dash-muted{
  fill: var(--dash-muted);
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.\\!p-0{
  padding: 0px !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-px{
  padding: 1px;
}
.\\!px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[3px\\]{
  padding-left: 3px;
  padding-right: 3px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[clamp\\(48px\\2c 10vh\\2c 120px\\)\\]{
  padding-top: clamp(48px,10vh,120px);
  padding-bottom: clamp(48px,10vh,120px);
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.\\!pt-4{
  padding-top: 1rem !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-3\\.5{
  padding-bottom: 0.875rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-\\[max\\(0\\.75rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(0.75rem,env(safe-area-inset-bottom));
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[130px\\]{
  padding-left: 130px;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-3\\.5{
  padding-right: 0.875rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-3\\.5{
  padding-top: 0.875rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.\\!text-center{
  text-align: center !important;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-fontFamily{
  font-family: var(--fontFamily, var(--app-font-family));
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: var(--app-font-family);
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[21px\\]{
  font-size: 21px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[7px\\]{
  font-size: 7px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9\\.5px\\]{
  font-size: 9.5px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-\\[clamp\\(1\\.875rem\\2c 4\\.4vw\\2c 3rem\\)\\]{
  font-size: clamp(1.875rem,4.4vw,3rem);
}
.text-\\[clamp\\(4\\.5rem\\2c 14vw\\2c 8rem\\)\\]{
  font-size: clamp(4.5rem,14vw,8rem);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-headerHeadingFontSize{
  font-size: var(--header-heading-fontSize);
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-typographyHeadingFontSize{
  font-size: var(--typography-heading-fontSize);
}
.text-typographyLabelsFontSize{
  font-size: var(--typography-labels-fontSize);
}
.text-typographySubheadingFontSize{
  font-size: var(--typography-subHeading-fontSize);
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-headerHeadingFontWeight{
  font-weight: var(--header-heading-fontWeight);
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.font-typographyHeadingFontWeight{
  font-weight: var(--typography-heading-fontWeight);
}
.font-typographyLabelsFontWeight{
  font-weight: var(--typography-labels-fontWeight);
}
.font-typographySubheadingFontWeight{
  font-weight: var(--typography-subHeading-fontWeight);
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-\\[1\\.15\\]{
  line-height: 1.15;
}
.leading-\\[1\\.1\\]{
  line-height: 1.1;
}
.leading-\\[1\\.5\\]{
  line-height: 1.5;
}
.leading-\\[1\\.6\\]{
  line-height: 1.6;
}
.leading-\\[13px\\]{
  line-height: 13px;
}
.leading-\\[20px\\]{
  line-height: 20px;
}
.leading-\\[34px\\]{
  line-height: 34px;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.025em\\]{
  letter-spacing: -0.025em;
}
.tracking-\\[-0\\.03em\\]{
  letter-spacing: -0.03em;
}
.tracking-\\[-0\\.05em\\]{
  letter-spacing: -0.05em;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-gray-700{
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.\\!text-inherit{
  color: inherit !important;
}
.text-\\[\\#0EA5E9\\]{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity));
}
.text-\\[\\#111a45\\]{
  --tw-text-opacity: 1;
  color: rgb(17 26 69 / var(--tw-text-opacity));
}
.text-\\[\\#1a0dab\\]{
  --tw-text-opacity: 1;
  color: rgb(26 13 171 / var(--tw-text-opacity));
}
.text-\\[\\#324ECF\\]{
  --tw-text-opacity: 1;
  color: rgb(50 78 207 / var(--tw-text-opacity));
}
.text-\\[\\#4361EE\\]{
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity));
}
.text-\\[\\#5A5881\\]{
  --tw-text-opacity: 1;
  color: rgb(90 88 129 / var(--tw-text-opacity));
}
.text-\\[\\#6575FE\\]{
  --tw-text-opacity: 1;
  color: rgb(101 117 254 / var(--tw-text-opacity));
}
.text-\\[\\#6B6B6B\\]{
  --tw-text-opacity: 1;
  color: rgb(107 107 107 / var(--tw-text-opacity));
}
.text-\\[\\#7B799A\\]{
  --tw-text-opacity: 1;
  color: rgb(123 121 154 / var(--tw-text-opacity));
}
.text-\\[\\#84CC16\\]{
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
.text-\\[\\#8fa2ff\\]{
  --tw-text-opacity: 1;
  color: rgb(143 162 255 / var(--tw-text-opacity));
}
.text-\\[\\#D946EF\\]{
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity));
}
.text-\\[\\#EC4899\\]{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity));
}
.text-\\[\\#e4e4ef\\]{
  --tw-text-opacity: 1;
  color: rgb(228 228 239 / var(--tw-text-opacity));
}
.text-\\[color\\:var\\(--dash-day\\)\\]{
  color: var(--dash-day);
}
.text-\\[var\\(--dash-accent\\)\\]{
  color: var(--dash-accent);
}
.text-accent-foreground{
  --tw-text-opacity: 1;
  color: hsl(from var(--accent-foreground) h s l / var(--tw-text-opacity));
}
.text-amber-100{
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity));
}
.text-amber-200\\/70{
  color: rgb(253 230 138 / 0.7);
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.text-cardTextColor{
  color: var(--card-color);
}
.text-dash-accent{
  color: var(--dash-accent);
}
.text-dash-accentInk{
  color: var(--dash-accent-ink);
}
.text-dash-active{
  color: var(--dash-active);
}
.text-dash-border{
  color: var(--dash-border);
}
.text-dash-cyanInk{
  color: var(--dash-cyan-ink);
}
.text-dash-dangerInk{
  color: var(--dash-danger-ink);
}
.text-dash-muted{
  color: var(--dash-muted);
}
.text-dash-purpleInk{
  color: var(--dash-purple-ink);
}
.text-dash-success{
  color: var(--dash-success);
}
.text-dash-successInk{
  color: var(--dash-success-ink);
}
.text-dash-text{
  color: var(--dash-text);
}
.text-dash-text2{
  color: var(--dash-text2);
}
.text-dash-warningInk{
  color: var(--dash-warning-ink);
}
.text-destructive{
  --tw-text-opacity: 1;
  color: hsl(from var(--destructive) h s l / var(--tw-text-opacity));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.text-emerald-400\\/70{
  color: rgb(52 211 153 / 0.7);
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.text-foreground{
  --tw-text-opacity: 1;
  color: hsl(from var(--foreground) h s l / var(--tw-text-opacity));
}
.text-foreground\\/80{
  color: hsl(from var(--foreground) h s l / 0.8);
}
.text-foreground\\/90{
  color: hsl(from var(--foreground) h s l / 0.9);
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-headerHeadingTextColor{
  color: var(--header-heading-color);
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
.text-muted-foreground{
  --tw-text-opacity: 1;
  color: hsl(from var(--muted-foreground) h s l / var(--tw-text-opacity));
}
.text-muted-foreground\\/40{
  color: hsl(from var(--muted-foreground) h s l / 0.4);
}
.text-muted-foreground\\/45{
  color: hsl(from var(--muted-foreground) h s l / 0.45);
}
.text-muted-foreground\\/80{
  color: hsl(from var(--muted-foreground) h s l / 0.8);
}
.text-primary{
  --tw-text-opacity: 1;
  color: hsl(from var(--primary) h s l / var(--tw-text-opacity));
}
.text-primary-foreground{
  --tw-text-opacity: 1;
  color: hsl(from var(--primary-foreground) h s l / var(--tw-text-opacity));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-sky-100{
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity));
}
.text-sky-300{
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
.text-transparent{
  color: transparent;
}
.text-typographyHeadingTextColor{
  color: var(--typography-heading-color);
}
.text-typographyLabelsTextColor{
  color: var(--typography-labels-color);
}
.text-typographySubHeadingTextColor{
  color: var(--typography-subHeading-color);
}
.text-violet-200{
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity));
}
.text-vjwDanger{
  --tw-text-opacity: 1;
  color: hsl(from var(--color-danger) h s l / var(--tw-text-opacity));
}
.text-vjwPrimary{
  --tw-text-opacity: 1;
  color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/45{
  color: rgb(255 255 255 / 0.45);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/55{
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/65{
  color: rgb(255 255 255 / 0.65);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
.text-zinc-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
.text-zinc-700{
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity));
}
.text-zinc-800{
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity));
}
.underline{
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.line-through{
  -webkit-text-decoration-line: line-through;
          text-decoration-line: line-through;
}
.no-underline{
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}
.decoration-muted-foreground\\/40{
  -webkit-text-decoration-color: hsl(from var(--muted-foreground) h s l / 0.4);
          text-decoration-color: hsl(from var(--muted-foreground) h s l / 0.4);
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-\\[3px\\]{
  text-underline-offset: 3px;
}
.\\!accent-vjwAccent{
  accent-color: hsl(from var(--color-accent) h s l / 1) !important;
}
.accent-\\[\\#324ECF\\]{
  accent-color: #324ECF;
}
.accent-\\[\\#6575FE\\]{
  accent-color: #6575FE;
}
.accent-\\[var\\(--dash-accent\\)\\]{
  accent-color: var(--dash-accent);
}
.accent-blue-600{
  accent-color: #2563eb;
}
.accent-dash-accent{
  accent-color: var(--dash-accent);
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.\\!shadow-none{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 -4px 16px rgba(0,0,0,0.12);
  --tw-shadow-colored: 0 -4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_rgba\\(110\\2c 231\\2c 183\\2c 0\\.8\\)\\]{
  --tw-shadow: 0 0 12px rgba(110,231,183,0.8);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_14px_rgba\\(111\\2c 123\\2c 255\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 0 14px rgba(111,123,255,0.35);
  --tw-shadow-colored: 0 0 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_18px_rgba\\(111\\2c 123\\2c 255\\2c 0\\.7\\)\\]{
  --tw-shadow: 0 0 18px rgba(111,123,255,0.7);
  --tw-shadow-colored: 0 0 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_30px_rgba\\(111\\2c 123\\2c 255\\2c 0\\.75\\)\\]{
  --tw-shadow: 0 0 30px rgba(111,123,255,0.75);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_var\\(--dash-accent\\)\\]{
  --tw-shadow: 0 0 8px var(--dash-accent);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_-10px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 10px 30px -10px rgba(15,23,42,0.6);
  --tw-shadow-colored: 0 10px 30px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_\\#E5E7EB\\]{
  --tw-shadow: 0 1px 0 #E5E7EB;
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_var\\(--dash-border\\)\\]{
  --tw-shadow: 0 1px 0 var(--dash-border);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\2c 0_8px_24px_-16px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.10\\)\\]{
  --tw-shadow: 0 1px 2px rgba(15,23,42,0.04),0 8px 24px -16px rgba(15,23,42,0.10);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 8px 24px -16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-20px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 24px 60px -20px rgba(2,6,23,0.6);
  --tw-shadow-colored: 0 24px 60px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_-2px_rgba\\(79\\2c 70\\2c 229\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 2px 8px -2px rgba(79,70,229,0.55);
  --tw-shadow-colored: 0 2px 8px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_-8px_rgba\\(50\\2c 78\\2c 207\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 8px 20px -8px rgba(50,78,207,0.55);
  --tw-shadow-colored: 0 8px 20px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_3px_0_0_var\\(--dash-accent\\)\\]{
  --tw-shadow: inset 3px 0 0 var(--dash-accent);
  --tw-shadow-colored: inset 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cardBoxShadow{
  --tw-shadow: var(--card-boxShadow);
  --tw-shadow-colored: var(--card-boxShadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[var\\(--dash-shadow-card\\)\\]{
  --tw-shadow-color: var(--dash-shadow-card);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--dash-shadow-pop\\)\\]{
  --tw-shadow-color: var(--dash-shadow-pop);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-card\\)\\]{
  --tw-shadow-color: var(--shadow-card);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-soft\\)\\]{
  --tw-shadow-color: var(--shadow-soft);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-400{
  --tw-shadow-color: #94a3b8;
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-\\[color\\:var\\(--dash-day\\)\\]{
  --tw-ring-color: var(--dash-day);
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity));
}
.ring-amber-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity));
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-dash-accent{
  --tw-ring-color: var(--dash-accent);
}
.ring-dash-accentSoft{
  --tw-ring-color: var(--dash-accent-soft);
}
.ring-dash-bg{
  --tw-ring-color: var(--dash-bg);
}
.ring-dash-bg2{
  --tw-ring-color: var(--dash-bg2);
}
.ring-dash-border{
  --tw-ring-color: var(--dash-border);
}
.ring-dash-borderStrong{
  --tw-ring-color: var(--dash-border-strong);
}
.ring-dash-danger{
  --tw-ring-color: var(--dash-danger);
}
.ring-dash-surface{
  --tw-ring-color: var(--dash-surface);
}
.ring-primary\\/15{
  --tw-ring-color: hsl(from var(--primary) h s l / 0.15);
}
.ring-vjwDanger{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--color-danger) h s l / var(--tw-ring-opacity));
}
.ring-vjwPrimary{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.ring-white\\/10{
  --tw-ring-color: rgb(255 255 255 / 0.1);
}
.ring-white\\/15{
  --tw-ring-color: rgb(255 255 255 / 0.15);
}
.ring-opacity-5{
  --tw-ring-opacity: 0.05;
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-4{
  --tw-ring-offset-width: 4px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(from var(--background) h s l / 1);
}
.ring-offset-dash-card{
  --tw-ring-offset-color: var(--dash-card);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\2c opacity\\]{
  transition-property: grid-template-rows,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.thin-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: #c4c4c4 transparent;
  }
.thin-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
.thin-scrollbar::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 9999px;
  }
.thin-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #a3a3a3;
  }
.\\[animation-delay\\:-0\\.15s\\]{
  animation-delay: -0.15s;
}
.\\[animation-delay\\:-0\\.3s\\]{
  animation-delay: -0.3s;
}
.\\[animation-delay\\:120ms\\]{
  animation-delay: 120ms;
}
.\\[animation-delay\\:150ms\\]{
  animation-delay: 150ms;
}
.\\[animation-delay\\:240ms\\]{
  animation-delay: 240ms;
}
.\\[animation-delay\\:300ms\\]{
  animation-delay: 300ms;
}
.\\[mask\\:radial-gradient\\(circle\\2c transparent_60px\\2c \\#000_61px\\)\\]{
  -webkit-mask: radial-gradient(circle,transparent 60px,#000 61px);
          mask: radial-gradient(circle,transparent 60px,#000 61px);
}

/* Candidate-facing JD preview content (R4). The global base reset strips list
   styles + margins, so restore readable typography for recruiter-authored JD HTML. */
.jd-prose {
  color: #334155;
  font-size: 0.9rem;
  line-height: 1.7;
}
.jd-prose h1,
.jd-prose h2,
.jd-prose h3 {
  font-weight: 700;
  color: #0f1729;
  margin: 1rem 0 0.5rem;
  line-height: 1.3;
}
.jd-prose h1 { font-size: 1.25rem; }
.jd-prose h2 { font-size: 1.1rem; }
.jd-prose h3 { font-size: 1rem; }
.jd-prose p { margin: 0.5rem 0; }
.jd-prose ul,
.jd-prose ol { margin: 0.5rem 0 0.75rem; padding-left: 1.25rem; }
.jd-prose ul { list-style: disc; }
.jd-prose ol { list-style: decimal; }
.jd-prose li { margin: 0.25rem 0; }
.jd-prose a { color: #324ecf; text-decoration: underline; }
.jd-prose strong { font-weight: 700; }

.job-description-container .ql-editor {
  height: 200px;
  overflow: auto;
}

.ql-editor {
      height: calc(100vh - 290px);
  overflow: auto;
 
}

#read-mode-quill .ql-editor {
  height: auto !important;
}
/* .MuiInputBase-root {
  background-color: rgb(232, 235, 249) !important;
  border-radius: 12px !important;
  height: 50px !important;
} */

.MuiOutlinedInput-notchedOutline {
  border-color: #e7e7f0 !important;
}

.MuiFormLabel-root {
  color: #1C1A4A !important; /* Dark navy label */
  font-weight: 500;
}

.Mui-focused .MuiFormLabel-root {
  color: #1C1A4A !important; /* Stay dark navy */
}

.MuiInputBase-input::placeholder {
  color: #676780 !important;
  opacity: 1;
}

.MuiFormHelperText-root {
  margin-left: 0 !important;
  color: #D60000 !important;
  font-size: 12px;
}

/* Error State */
.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: #C92525 !important;
}
/* Custom Scrollbar Styles */

/* Hide scrollbar but allow scrolling */
.scrollbar-hide {
  -ms-overflow-style: none !important; /* IE and Edge */
  scrollbar-width: none !important; /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari, Opera */
  width: 0 !important;
  height: 0 !important;
}

/* Css Ripple effect  */
@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.animate-ripple {
  animation: ripple 1.5s infinite;
}

.delay-300 {
  animation-delay: 0.3s;
}
.delay-600 {
  animation-delay: 0.6s;
}

/* ── Aurora background orbs (status screens) — slow living drift ───────────── */
@keyframes orb-float-a {
  0% { transform: translate(0px, 0px) scale(1); }
  50% { transform: translate(60px, 50px) scale(1.15); }
  100% { transform: translate(0px, 0px) scale(1); }
}
@keyframes orb-float-b {
  0% { transform: translate(0px, 0px) scale(1); }
  50% { transform: translate(-70px, -40px) scale(0.9); }
  100% { transform: translate(0px, 0px) scale(1); }
}
@keyframes orb-float-c {
  0% { transform: translate(0px, 0px) scale(1); }
  50% { transform: translate(40px, -60px) scale(1.2); }
  100% { transform: translate(0px, 0px) scale(1); }
}
/* Staggered entrance for guideline cards/list items (subtle gamified feel). */
@keyframes fade-in-up {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in-up { animation: fade-in-up 0.5s ease-out both; }
@media (prefers-reduced-motion: reduce) {
  .animate-fade-in-up { animation: none; }
}

/* AI interviewer voice bars — only rendered while the interviewer is speaking. */
@keyframes ai-wave {
  0%, 100% { transform: scaleY(0.3); }
  50% { transform: scaleY(1); }
}
.animate-ai-wave { animation: ai-wave 0.9s ease-in-out infinite; transform-origin: center; }
@media (prefers-reduced-motion: reduce) {
  .animate-ai-wave { animation: none; transform: scaleY(0.6); }
}

/* ── Toast notifications — slide-in + auto-dismiss progress bar ────────────── */
@keyframes toast-in {
  from { opacity: 0; transform: translateX(18px) scale(0.98); }
  to { opacity: 1; transform: translateX(0) scale(1); }
}
.animate-toast-in { animation: toast-in 0.28s cubic-bezier(0.22, 1, 0.36, 1) both; }
@keyframes toast-progress {
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
}
.animate-toast-progress {
  transform-origin: left;
  animation: toast-progress 5s linear forwards;
}
@media (prefers-reduced-motion: reduce) {
  .animate-toast-in { animation: none; }
  .animate-toast-progress { animation: none; }
}

.orb-a { animation: orb-float-a 18s ease-in-out infinite; }
.orb-b { animation: orb-float-b 24s ease-in-out infinite; }
.orb-c { animation: orb-float-c 21s ease-in-out infinite; }
@media (prefers-reduced-motion: reduce) {
  .orb-a,
  .orb-b,
  .orb-c {
    animation: none;
  }
}

/* Desktop view */
@media (min-width: 899px) {
  ::-webkit-scrollbar {
    width: 8px;
  }
}

/* Mobile view */
@media (max-width: 900px) {
  /* ::-webkit-scrollbar {
  } */
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #acacac;
  border-radius: 10px;
  border: 2px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #acacac;
}

.horizontal-scroll-container {
  overflow-x: auto;
  scrollbar-width: thin;
  scroll-behavior: smooth;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */
}

.scroll-container {
  overflow-y: auto;
  scrollbar-width: thin;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */
}

.react-datepicker-popper { /* Ensure on top of modal */
  z-index: 9999 !important; /* above modals */
}

.react-datepicker__input-container input {
  padding: 0.5rem 2rem;
}

.react-datepicker__header {
  background-color: #f9fafb; /* gray-50 */
  border-bottom: 1px solid #e5e7eb;
}

.react-datepicker__day--selected,
.react-datepicker__time-list-item--selected {
  background-color: #6575FE !important;
  color: white !important;
}

.react-datepicker__day--keyboard-selected {
  background-color: #e0e7ff;
}

/* ═══════════════════════════════════════════════════════════════════════════
   VRITI DASHBOARD DESIGN SYSTEM (.vdash)
   Scoped token set for the recruiter dashboard shell only. Dark is the default
   theme; \`.vdash-light\` overrides every token, so components style once with
   Tailwind \`dash-*\` utilities (see tailwind.config.js) and get both themes.
   8px spacing system · Inter · small radii · soft borders · subtle elevation.
   ═══════════════════════════════════════════════════════════════════════════ */
.vdash {
  /* surfaces — soft layered dark (no pure black, low-strain contrast) */
  --dash-bg: #0a0c10;
  --dash-bg2: #0d0f14;
  --dash-surface: #171b22; /* elevated panels, inputs, nested surfaces */
  --dash-card: #12151b;
  --dash-card-hover: #171b22;
  --dash-border: rgba(255, 255, 255, 0.07);
  --dash-border-strong: rgba(255, 255, 255, 0.13);
  /* ink — off-white, comfortable for long sessions */
  --dash-text: #f3f4f6;
  --dash-text2: #b6bec9;
  --dash-muted: #8a93a3;
  /* interaction */
  --dash-hover: rgba(255, 255, 255, 0.05);
  --dash-active: rgba(255, 255, 255, 0.09);
  /* accents — "ink" variants are readable as small text on the card surface */
  --dash-accent: #3b82f6;
  --dash-accent-hover: #2563eb;
  --dash-accent-ink: #60a5fa;
  --dash-accent-soft: rgba(59, 130, 246, 0.12);
  --dash-purple: #8b5cf6;
  --dash-purple-ink: #a78bfa;
  --dash-purple-soft: rgba(139, 92, 246, 0.12);
  --dash-cyan: #06b6d4;
  --dash-cyan-ink: #22d3ee;
  --dash-cyan-soft: rgba(6, 182, 212, 0.11);
  --dash-success: #10b981;
  --dash-success-ink: #34d399;
  --dash-success-soft: rgba(16, 185, 129, 0.11);
  --dash-warning: #f59e0b;
  --dash-warning-ink: #fbbf24;
  --dash-warning-soft: rgba(245, 158, 11, 0.11);
  --dash-danger: #ef4444;
  --dash-danger-ink: #f87171;
  --dash-danger-soft: rgba(239, 68, 68, 0.11);
  /* charts */
  --dash-grid: rgba(182, 190, 201, 0.1);
  --dash-tick: #8a93a3;

  /* ── Categorical series palette ──────────────────────────────────────
     Eight fixed slots, ASSIGNED IN ORDER and never cycled — a ninth series
     folds into "Other" rather than reusing slot 1, because a repeated hue
     makes two different things look like the same thing.

     These are the dark-surface steps; \`.vdash-light\` re-steps the SAME eight
     hues for the light surface. Not an automatic flip: a hue readable on
     #12151b is not readable on #ffffff, and vice versa.

     Validated as a set against this surface (OKLab ΔE, colour-vision
     simulation): worst adjacent pair separates by ΔE 8.4 under protanopia and
     19.3 in normal vision, every slot clears 3:1 contrast. The palette this
     replaced put emerald beside magenta at ΔE 4.9 — indistinguishable to a
     deuteranope, i.e. two series that read as one. */
  --dash-series-1: #3987e5;
  --dash-series-2: #d95926;
  --dash-series-3: #199e70;
  --dash-series-4: #c98500;
  --dash-series-5: #d55181;
  --dash-series-6: #008300;
  --dash-series-7: #9085e9;
  --dash-series-8: #e66767;

  /* ── Interview lifecycle phases ──────────────────────────────────────
     A FIXED colour per phase, so "before / during / after" means the same
     colour on every chart, card and table in the console. Colour follows the
     phase, never its rank — a filter that drops a phase must not repaint the
     survivors. Validated as its own set in both modes. */
  --dash-phase-pre: #3987e5;
  --dash-phase-in: #d95926;
  --dash-phase-post: #199e70;
  --dash-phase-platform: #9085e9;
  --dash-phase-unknown: #e66767;

  /* elevation */
  --dash-shadow-card: 0 1px 2px rgba(0, 0, 0, 0.18);
  --dash-shadow-pop: 0 8px 24px -10px rgba(0, 0, 0, 0.4);
  --dash-scrollbar: rgba(138, 147, 163, 0.3);

  /* Hiring funnel: colour carries meaning, not identity (the axis names each bar).
     Validated with the dataviz palette checks against the card surface. */
  --dash-funnel-total: #94a3b8;
  --dash-funnel-pipeline: #3b82f6;
  --dash-funnel-good: #059669;
  --dash-funnel-bad: #ef4444;
  --dash-funnel-dropped: #64748b;
  --dash-funnel-on-total: #0f172a;

  font-family: 'Inter', var(--app-font-family);
  color-scheme: dark; /* native date inputs / selects follow the theme */
}

.vdash.vdash-light {
  /* Layered so white cards read clearly: off-white frame, cool-grey panel, white cards. */
  --dash-bg: #e4e9f0;
  --dash-accent: #4f46e5;
  --dash-accent-hover: #4338ca;
  --dash-bg2: #f7f9fc;
  --dash-surface: #ffffff;
  --dash-card: #ffffff;
  --dash-card-hover: #f8fafc;
  --dash-border: rgba(15, 23, 42, 0.12);
  --dash-border-strong: rgba(15, 23, 42, 0.2);
  --dash-text: #0f172a;
  --dash-text2: #475569;
  --dash-muted: #526175; /* 5.2:1 on the panel, 6.3:1 on cards (was 2.6:1) */
  --dash-hover: rgba(15, 23, 42, 0.04);
  --dash-active: rgba(15, 23, 42, 0.07);
  --dash-accent-ink: #4f46e5;
  --dash-accent-soft: rgba(79, 70, 229, 0.09);
  --dash-funnel-total: #1e293b;
  --dash-funnel-pipeline: #4f46e5;
  --dash-funnel-good: #059669;
  --dash-funnel-bad: #dc2626;
  --dash-funnel-dropped: #64748b;
  --dash-funnel-on-total: #ffffff;
  --dash-purple-ink: #7c3aed;
  --dash-purple-soft: rgba(139, 92, 246, 0.1);
  --dash-cyan-ink: #0891b2;
  --dash-cyan-soft: rgba(6, 182, 212, 0.1);
  --dash-success-ink: #059669;
  --dash-success-soft: rgba(16, 185, 129, 0.12);
  --dash-warning-ink: #b45309;
  --dash-warning-soft: rgba(245, 158, 11, 0.14);
  --dash-danger-ink: #dc2626;
  --dash-danger-soft: rgba(239, 68, 68, 0.1);
  --dash-grid: rgba(15, 23, 42, 0.07);
  --dash-tick: #526175;

  /* The same eight hues, re-stepped for the light surface — selected against
     it, not lightened programmatically from the dark set. */
  --dash-series-1: #2a78d6;
  --dash-series-2: #eb6834;
  --dash-series-3: #1baf7a;
  --dash-series-4: #eda100;
  --dash-series-5: #e87ba4;
  --dash-series-6: #008300;
  --dash-series-7: #4a3aa7;
  --dash-series-8: #e34948;

  --dash-phase-pre: #2a78d6;
  --dash-phase-in: #eb6834;
  --dash-phase-post: #1baf7a;
  --dash-phase-platform: #4a3aa7;
  --dash-phase-unknown: #e34948;
  --dash-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 6px -2px rgba(15, 23, 42, 0.06);
  --dash-shadow-pop: 0 12px 32px -8px rgba(15, 23, 42, 0.18);
  --dash-scrollbar: rgba(100, 116, 139, 0.35);
  color-scheme: light;
}

/* Greeting-name gradient: deep Vriti violet on light, lifted violet on dark */
.vdash {
  --dash-name-grad: linear-gradient(92deg, #f5f5f5, #9ca3af 55%, #4b5563);
  --dash-day: #9db1f7; /* calendar day numbers — soft on layered dark */
}

.vdash.vdash-light {
  --dash-name-grad: linear-gradient(92deg, #324FCF, #1f3494 55%, #1d295c);
  --dash-day: #324fcf;
}


.vdash .dash-display {
  font-family: 'Space Grotesk', 'Inter', var(--app-font-family);
  letter-spacing: -0.02em;
}

/* Accessible keyboard focus everywhere inside the dashboard */
.vdash :focus-visible {
  outline: 2px solid var(--dash-accent);
  outline-offset: 2px;
  border-radius: 4px;
}

/* Themed scrollbars inside the dashboard */
.vdash *::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.vdash *::-webkit-scrollbar-track {
  background: transparent;
}
.vdash *::-webkit-scrollbar-thumb {
  background-color: var(--dash-scrollbar);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.vdash * {
  scrollbar-width: thin;
  scrollbar-color: var(--dash-scrollbar) transparent;
}

/* Skeleton loader — one shimmer for every loading state in the app (see
   components/ui/skeleton). Shape (size, radius) comes from utilities on the
   element; this only paints the surface, so it sits in the components layer
   where a \`rounded-*\` or \`h-*\` utility still wins. Tokens fall back to neutral
   values outside a .vdash scope (candidate pages, the pre-theme route gate). */
@keyframes dash-shimmer {
  100% {
    transform: translateX(100%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .dash-skeleton::after {
    animation: none;
    display: none;
  }
}

/* Micro-interaction entrances (150–250ms, subtle) */
@keyframes dash-fade-up {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dash-scale-in {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.vdash .dash-fade-up {
  animation: dash-fade-up 0.22s ease-out both;
}
.vdash .dash-pop {
  animation: dash-scale-in 0.16s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@media (prefers-reduced-motion: reduce) {
  .vdash .dash-fade-up,
  .vdash .dash-pop {
    animation: none;
  }
}

/* Card primitive — border + hover elevation shared by every dashboard widget */
.vdash .dash-card {
  background: var(--dash-card);
  border: 1px solid var(--dash-border);
  border-radius: 12px;
  box-shadow: var(--dash-shadow-card);
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
/* App shell — from aiMd up the main column is a rounded panel inset on the
   sidebar's canvas, so sidebar and content read as one surface instead of two
   boxes split by a rule. Phones keep the full-bleed layout. */
@media (min-width: 768px) {
  .vdash .dash-shell-panel {
    margin: 8px 8px 8px 0;
    border: 1px solid var(--dash-border);
    border-radius: 16px;
    box-shadow: var(--dash-shadow-card);
    overflow: hidden;
  }
}
/* Wordmark — white-letter version on the dark theme, navy on light */
.vdash .dash-wordmark__dark,
.vdash.vdash-light .dash-wordmark__light {
  display: none;
}
.vdash.vdash-light .dash-wordmark__dark {
  display: block;
}
/* Org chart — nested <ul>/<li> with elbow connectors drawn by pseudo-elements.
   ul::before drops from the manager; each li's ::before/::after are the two
   halves of the horizontal rail, and ::after (or ::before on the last child)
   carries the drop into the child card. */
.vdash .org-tree-canvas {
  background-image: radial-gradient(var(--dash-border-strong) 1px, transparent 1px);
  background-size: 18px 18px;
}
.vdash .org-tree {
  --org-line: var(--dash-border-strong);
  --org-gap: 28px;
  width: -webkit-max-content;
  width: max-content;
  min-width: 100%;
  padding: 28px 24px 40px;
}
.vdash .org-tree ul {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: var(--org-gap) 0 0;
  list-style: none;
}
.vdash .org-tree > ul {
  padding-top: 0;
}
.vdash .org-tree li {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--org-gap) 10px 0;
}
.vdash .org-tree li::before,
.vdash .org-tree li::after {
  content: '';
  position: absolute;
  top: 0;
  right: 50%;
  width: 50%;
  height: var(--org-gap);
  border-top: 2px solid var(--org-line);
}
.vdash .org-tree li::after {
  right: auto;
  left: 50%;
  border-left: 2px solid var(--org-line);
}
.vdash .org-tree li:only-child {
  padding-top: 0;
}
.vdash .org-tree li:only-child::before,
.vdash .org-tree li:only-child::after,
.vdash .org-tree > ul > li::before,
.vdash .org-tree > ul > li::after {
  display: none;
}
.vdash .org-tree > ul > li {
  padding-top: 0;
}
.vdash .org-tree li:first-child::before,
.vdash .org-tree li:last-child::after {
  border: 0 none;
}
.vdash .org-tree li:last-child::before {
  border-right: 2px solid var(--org-line);
  border-radius: 0 10px 0 0;
}
.vdash .org-tree li:first-child::after {
  border-radius: 10px 0 0 0;
}
.vdash .org-tree ul ul::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  height: var(--org-gap);
  border-left: 2px solid var(--org-line);
}
.vdash .org-tree__node {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vdash .org-tree__toggle {
  position: relative;
  z-index: 1;
  margin-top: -12px;
}
/* Modal backdrops carry \`.vdash\` for theming, which the light-mode aurora rule
   above would repaint as an opaque page — hiding the app behind the dialog.
   Keep them a translucent dim. */
.vdash.vdash-light.dash-overlay,
.vdash.dash-overlay {
  background-color: rgba(15, 23, 42, 0.45);
  background-image: none;
}

/* Native selects: one consistent field look with a drawn chevron. Selects that
   already draw their own (class \`appearance-none\`) are left alone. */
.vdash select:not([multiple]):not(.appearance-none) {
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.65rem center;
  background-size: 16px 16px;
  padding-right: 2.25rem;
  cursor: pointer;
}
.vdash select:not([multiple]):not(.appearance-none):focus {
  outline: none;
  border-color: var(--dash-accent);
  box-shadow: 0 0 0 3px var(--dash-accent-soft);
}
/* Rendered job-description HTML: real headings, lists and spacing. */
.vdash .dash-richtext {
  color: var(--dash-text2);
  font-size: 14px;
  line-height: 1.7;
}
.vdash .dash-richtext > * + * {
  margin-top: 0.6em;
}
.vdash .dash-richtext h1,
.vdash .dash-richtext h2,
.vdash .dash-richtext h3,
.vdash .dash-richtext h4 {
  color: var(--dash-text);
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.35;
  margin-top: 1.4em;
}
.vdash .dash-richtext h1 { font-size: 1.35em; }
.vdash .dash-richtext h2 { font-size: 1.15em; }
.vdash .dash-richtext h3,
.vdash .dash-richtext h4 { font-size: 1em; }
.vdash .dash-richtext > :first-child { margin-top: 0; }
.vdash .dash-richtext ul,
.vdash .dash-richtext ol {
  padding-left: 1.25em;
}
.vdash .dash-richtext ul { list-style: disc; }
.vdash .dash-richtext ol { list-style: decimal; }
.vdash .dash-richtext li[data-list='bullet'] { list-style-type: disc; }
.vdash .dash-richtext li[data-list='ordered'] { list-style-type: decimal; }
.vdash .dash-richtext .ql-ui { display: none; }
.vdash .dash-richtext li + li { margin-top: 0.3em; }
.vdash .dash-richtext li::marker { color: var(--dash-muted); }
.vdash .dash-richtext strong,
.vdash .dash-richtext b { color: var(--dash-text); font-weight: 600; }
.vdash .dash-richtext a { color: var(--dash-accent-ink); text-decoration: underline; text-underline-offset: 2px; }
/* Comfortable reading rhythm for long sessions */
.vdash {
  line-height: 1.55;
}
.vdash .dash-card-hover:hover {
  border-color: var(--dash-border-strong);
  box-shadow: var(--dash-shadow-pop);
  transform: translateY(-1px);
}

/* Native date inputs render with theme-appropriate indicator */
.vdash input[type='date'] {
  color-scheme: inherit;
}

/* Light mode: no page-wide gradient. The old blue "aurora" painted the shell and
   the main panel with one fixed wash, which erased the frame → panel → card
   layering and left white cards floating on a pale haze. Each layer now shows its
   own token (--dash-bg2 frame, --dash-bg panel, --dash-card cards).
   Cards are plain white: a sheen toward grey only narrowed the card/panel gap. */

/* JD description (read-mode quill) — compact, columned on wide screens, and
   token-colored so recruiter-authored inline colors stay readable in dark mode. */
.vdash .jd-desc-columns .ql-container {
  font-size: 15px;
}
.vdash .jd-desc-columns .ql-editor {
  padding: 0;
  line-height: 1.7;
  color: var(--dash-text2);
}
.vdash .jd-desc-columns .ql-editor p {
  margin: 0 0 0.35rem;
}
.vdash .jd-desc-columns .ql-editor,
.vdash .jd-desc-columns .ql-editor * {
  color: var(--dash-text2) !important;
  background: transparent !important;
}
.vdash .jd-desc-columns .ql-editor strong,
.vdash .jd-desc-columns .ql-editor h1,
.vdash .jd-desc-columns .ql-editor h2,
.vdash .jd-desc-columns .ql-editor h3 {
  color: var(--dash-text) !important;
}
@media (min-width: 1024px) {
  .vdash .jd-desc-columns .ql-editor {
    column-count: 2;
    column-gap: 3rem;
    column-rule: 1px solid var(--dash-border);
  }
}

/* JD editors (original + AI-generated): the Quill "snow" theme paints a stark
   light (#ccc) border on its toolbar/container that reads as a white box inside
   the already dash-bordered card. Drop that inner border and theme the toolbar
   to dash tokens so the editor matches the dashboard in dark and light. */
.vdash .jd-editor-quill .ql-container.ql-snow {
  border: none;
}
.vdash .jd-editor-quill .ql-toolbar.ql-snow {
  border: none;
  border-bottom: 1px solid var(--dash-border);
}
.vdash .jd-editor-quill .ql-toolbar.ql-snow .ql-stroke {
  stroke: var(--dash-text2);
}
.vdash .jd-editor-quill .ql-toolbar.ql-snow .ql-fill {
  fill: var(--dash-text2);
}
.vdash .jd-editor-quill .ql-toolbar.ql-snow .ql-picker {
  color: var(--dash-text2);
}

/* Striped progress fill — black/gray/#324FCF scheme with slow-moving stripes */
.vdash .dash-progress-striped {
  background-image:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.16) 0 8px,
      transparent 8px 16px
    ),
    linear-gradient(90deg, #111827, #4b5563 45%, #324fcf);
  background-size:
    24px 24px,
    100% 100%;
  animation: dash-stripes 1.2s linear infinite;
}
@keyframes dash-stripes {
  from {
    background-position:
      0 0,
      0 0;
  }
  to {
    background-position:
      24px 0,
      0 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .vdash .dash-progress-striped {
    animation: none;
  }
}

/* Chrome autofill paints its own blue box inside the raw <input>, which breaks
   rounded fields with end-adornments (login/password eye icon). Repaint it with
   the field surface instead — scoped to the token system. */
.vdash input:-webkit-autofill,
.vdash input:-webkit-autofill:hover,
.vdash input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
  -webkit-text-fill-color: var(--dash-text);
  caret-color: var(--dash-text);
  border-radius: inherit;
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}
.vdash:not(.vdash-light) input:-webkit-autofill,
.vdash:not(.vdash-light) input:-webkit-autofill:hover,
.vdash:not(.vdash-light) input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px var(--dash-surface) inset;
}

/* ══════════════════════════════════════════════════════════════════════════════
   MOBILE-ONLY LAYOUT HELPERS

   Every rule below lives inside a \`max-width\` media query AND is gated behind an
   explicit opt-in class, so desktop CSS (>= 640px / >= 768px) is byte-for-byte
   unchanged and no component picks these up by accident. Used by the Job
   Postings board, the Interview Report and the Schedule Interview flow to hit
   native-app touch ergonomics (48px targets, 16px gutters, 8px rhythm) without
   duplicating the approved desktop layout.
   ══════════════════════════════════════════════════════════════════════════════ */

/* \`m-touch-form\` — opt-in on a form/step wrapper. Grows every real text control
   inside it to a 48px touch target on phones. Checkbox/radio/file inputs and
   anything explicitly opted out with \`data-no-touch-grow\` keep their size, as do
   the narrow inline numeric fields (percentages) that must stay compact. */
@media (max-width: 639px) {
  .m-touch-form input:not([type='checkbox']):not([type='radio']):not([type='file']):not([data-no-touch-grow]),
  .m-touch-form select:not([data-no-touch-grow]),
  .m-touch-form textarea:not([data-no-touch-grow]) {
    min-height: 48px;
  }

  /* Primary actions inside an opted-in form span the full width on phones. */
  .m-touch-form button[type='submit']:not([data-no-touch-grow]) {
    width: 100%;
    min-height: 48px;
  }

  /* react-select sets its control height as an inline style, so it reads this var
     instead of a hard 42px (see utils/dash-select-styles.ts). */
  .m-touch-form {
    --dash-select-min-h: 48px;
  }

  /* react-datepicker renders \`withPortal\` (a centred sheet). Its default
     day-grid + time-column is ~330px wide, which overflows a 320px viewport —
     clamp the sheet and let the time column scroll instead. */
  .react-datepicker__portal .react-datepicker {
    max-width: calc(100vw - 24px);
    font-size: 0.8rem;
  }
  .react-datepicker__portal .react-datepicker__time-container,
  .react-datepicker__portal .react-datepicker__time-container .react-datepicker__time-box {
    width: 72px;
  }
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__day-name {
    width: 1.6rem;
    line-height: 1.6rem;
    margin: 0.12rem;
  }

  /* Quill toolbars wrap instead of clipping their format buttons. */
  .m-quill-wrap .ql-toolbar.ql-snow {
    display: flex;
    flex-wrap: wrap;
    row-gap: 2px;
  }
}

/* \`m-fullscreen-sheet\` — opt-in on \`Modal\`'s card (see \`mobileFullScreen\`).
   Turns a centred dialog into an edge-to-edge sheet on phones/small tablets so
   long forms get the whole viewport and the on-screen keyboard can never cover
   a field (the card's own body is the scroll container). Uses \`dvh\` so the
   sheet tracks the browser's collapsing toolbars. */
@media (max-width: 767px) {
  .m-fullscreen-sheet {
    max-width: none !important;
    width: 100% !important;
    /* vh first as the fallback, dvh second for browsers that support it. */
    height: 100vh !important;
    max-height: 100vh !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
    border-radius: 0 !important;
  }
  .m-fullscreen-backdrop {
    padding: 0 !important;
    align-items: stretch !important;
  }
}
.first-letter\\:uppercase::first-letter{
  text-transform: uppercase;
}
.placeholder\\:text-xs::placeholder{
  font-size: 0.75rem;
  line-height: 1rem;
}
.placeholder\\:font-normal::placeholder{
  font-weight: 400;
}
.placeholder\\:text-dash-muted::placeholder{
  color: var(--dash-muted);
}
.placeholder\\:opacity-70::placeholder{
  opacity: 0.7;
}
.first\\:mt-0:first-child{
  margin-top: 0px;
}
.first\\:rounded-l-full:first-child{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.first\\:pt-0:first-child{
  padding-top: 0px;
}
.last\\:mb-0:last-child{
  margin-bottom: 0px;
}
.last\\:rounded-r-full:last-child{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:pb-0:last-child{
  padding-bottom: 0px;
}
.focus-within\\:border-dash-accent:focus-within{
  border-color: var(--dash-accent);
}
.focus-within\\:opacity-100:focus-within{
  opacity: 1;
}
.focus-within\\:ring-1:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-\\[3px\\]:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-dash-accentSoft:focus-within{
  --tw-ring-color: var(--dash-accent-soft);
}
.focus-within\\:ring-vjwPrimary:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}
.hover\\:-translate-y-0:hover{
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-px:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.03\\]:hover{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:\\!border-vjwPrimary:hover{
  --tw-border-opacity: 1 !important;
  border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.hover\\:border-\\[var\\(--dash-accent\\)\\]:hover{
  border-color: var(--dash-accent);
}
.hover\\:border-dash-accent:hover{
  border-color: var(--dash-accent);
}
.hover\\:border-dash-border:hover{
  border-color: var(--dash-border);
}
.hover\\:border-dash-borderStrong:hover{
  border-color: var(--dash-border-strong);
}
.hover\\:border-gray-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.hover\\:border-primary:hover{
  --tw-border-opacity: 1;
  border-color: hsl(from var(--primary) h s l / var(--tw-border-opacity));
}
.hover\\:border-b-vjwPrimary:hover{
  --tw-border-opacity: 1;
  border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.hover\\:\\!bg-dash-dangerSoft:hover{
  background-color: var(--dash-danger-soft) !important;
}
.hover\\:bg-\\[\\#273db0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(39 61 176 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#324ECF\\]\\/20:hover{
  background-color: rgb(50 78 207 / 0.2);
}
.hover\\:bg-\\[\\#EEF1FC\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 241 252 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#e23a6a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 58 106 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#ebedfa\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(235 237 250 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.hover\\:bg-black\\/20:hover{
  background-color: rgb(0 0 0 / 0.2);
}
.hover\\:bg-black\\/70:hover{
  background-color: rgb(0 0 0 / 0.7);
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.hover\\:bg-dash-accent:hover{
  background-color: var(--dash-accent);
}
.hover\\:bg-dash-accentHover:hover{
  background-color: var(--dash-accent-hover);
}
.hover\\:bg-dash-accentInk:hover{
  background-color: var(--dash-accent-ink);
}
.hover\\:bg-dash-accentSoft:hover{
  background-color: var(--dash-accent-soft);
}
.hover\\:bg-dash-active:hover{
  background-color: var(--dash-active);
}
.hover\\:bg-dash-cardHover:hover{
  background-color: var(--dash-card-hover);
}
.hover\\:bg-dash-danger:hover{
  background-color: var(--dash-danger);
}
.hover\\:bg-dash-dangerSoft:hover{
  background-color: var(--dash-danger-soft);
}
.hover\\:bg-dash-hover:hover{
  background-color: var(--dash-hover);
}
.hover\\:bg-dash-surface:hover{
  background-color: var(--dash-surface);
}
.hover\\:bg-dash-warningSoft:hover{
  background-color: var(--dash-warning-soft);
}
.hover\\:bg-destructive\\/10:hover{
  background-color: hsl(from var(--destructive) h s l / 0.1);
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.hover\\:bg-green-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}
.hover\\:bg-muted:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--muted) h s l / var(--tw-bg-opacity));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(from var(--muted) h s l / 0.5);
}
.hover\\:bg-primary:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--primary) h s l / var(--tw-bg-opacity));
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(from var(--primary) h s l / 0.9);
}
.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
.hover\\:bg-vjwDanger\\/30:hover{
  background-color: hsl(from var(--color-danger) h s l / 0.3);
}
.hover\\:bg-vjwDanger\\/5:hover{
  background-color: hsl(from var(--color-danger) h s l / 0.05);
}
.hover\\:bg-vjwPrimary:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
}
.hover\\:bg-vjwSecondary:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/30:hover{
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9);
}
.hover\\:\\!text-dash-dangerInk:hover{
  color: var(--dash-danger-ink) !important;
}
.hover\\:text-\\[\\#20317E\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(32 49 126 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#2340b0\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(35 64 176 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#4c5de4\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(76 93 228 / var(--tw-text-opacity));
}
.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.hover\\:text-dash-accent:hover{
  color: var(--dash-accent);
}
.hover\\:text-dash-accentInk:hover{
  color: var(--dash-accent-ink);
}
.hover\\:text-dash-dangerInk:hover{
  color: var(--dash-danger-ink);
}
.hover\\:text-dash-text:hover{
  color: var(--dash-text);
}
.hover\\:text-dash-text2:hover{
  color: var(--dash-text2);
}
.hover\\:text-dash-warningInk:hover{
  color: var(--dash-warning-ink);
}
.hover\\:text-destructive:hover{
  --tw-text-opacity: 1;
  color: hsl(from var(--destructive) h s l / var(--tw-text-opacity));
}
.hover\\:text-foreground:hover{
  --tw-text-opacity: 1;
  color: hsl(from var(--foreground) h s l / var(--tw-text-opacity));
}
.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.hover\\:text-green-800:hover{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.hover\\:text-green-900:hover{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity));
}
.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
.hover\\:text-primary:hover{
  --tw-text-opacity: 1;
  color: hsl(from var(--primary) h s l / var(--tw-text-opacity));
}
.hover\\:text-primary-foreground:hover{
  --tw-text-opacity: 1;
  color: hsl(from var(--primary-foreground) h s l / var(--tw-text-opacity));
}
.hover\\:text-primary\\/80:hover{
  color: hsl(from var(--primary) h s l / 0.8);
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.hover\\:text-red-900:hover{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.hover\\:text-slate-200:hover{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.hover\\:text-vjwDanger:hover{
  --tw-text-opacity: 1;
  color: hsl(from var(--color-danger) h s l / var(--tw-text-opacity));
}
.hover\\:text-vjwDanger\\/80:hover{
  color: hsl(from var(--color-danger) h s l / 0.8);
}
.hover\\:text-vjwPrimary:hover{
  --tw-text-opacity: 1;
  color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover{
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-70:hover{
  opacity: 0.7;
}
.hover\\:opacity-75:hover{
  opacity: 0.75;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:opacity-95:hover{
  opacity: 0.95;
}
.hover\\:shadow-\\[0_6px_16px_-6px_rgba\\(79\\2c 70\\2c 229\\2c 0\\.7\\)\\]:hover{
  --tw-shadow: 0 6px 16px -6px rgba(79,70,229,0.7);
  --tw-shadow-colored: 0 6px 16px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[var\\(--dash-shadow-pop\\)\\]:hover{
  --tw-shadow-color: var(--dash-shadow-pop);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-1:hover{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-dash-accent:hover{
  --tw-ring-color: var(--dash-accent);
}
.hover\\:ring-vjwPrimary:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}
.focus\\:\\!border-2:focus{
  border-width: 2px !important;
}
.focus\\:\\!border-vjwDanger:focus{
  --tw-border-opacity: 1 !important;
  border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.focus\\:\\!border-vjwPrimary:focus{
  --tw-border-opacity: 1 !important;
  border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.focus\\:border-\\[\\#6575FE\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(101 117 254 / var(--tw-border-opacity));
}
.focus\\:border-\\[var\\(--dash-accent\\)\\]:focus{
  border-color: var(--dash-accent);
}
.focus\\:border-dash-accent:focus{
  border-color: var(--dash-accent);
}
.focus\\:border-dash-borderStrong:focus{
  border-color: var(--dash-border-strong);
}
.focus\\:bg-dash-dangerSoft:focus{
  background-color: var(--dash-danger-soft);
}
.focus\\:bg-dash-hover:focus{
  background-color: var(--dash-hover);
}
.focus\\:bg-vjwSecondary:focus{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}
.focus\\:text-dash-text:focus{
  color: var(--dash-text);
}
.focus\\:\\!outline-none:focus{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[3px\\]:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#324ECF\\]\\/30:focus{
  --tw-ring-color: rgb(50 78 207 / 0.3);
}
.focus\\:ring-\\[\\#324ECF\\]\\/40:focus{
  --tw-ring-color: rgb(50 78 207 / 0.4);
}
.focus\\:ring-blue-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity));
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
.focus\\:ring-dash-accent:focus{
  --tw-ring-color: var(--dash-accent);
}
.focus\\:ring-dash-accentSoft:focus{
  --tw-ring-color: var(--dash-accent-soft);
}
.focus\\:ring-dash-dangerSoft:focus{
  --tw-ring-color: var(--dash-danger-soft);
}
.focus\\:ring-vjwDanger:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--color-danger) h s l / var(--tw-ring-opacity));
}
.focus\\:ring-vjwPrimary:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:relative:focus-visible{
  position: relative;
}
.focus-visible\\:border-dash-accent:focus-visible{
  border-color: var(--dash-accent);
}
.focus-visible\\:\\!outline-none:focus-visible{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-4:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-inset:focus-visible{
  --tw-ring-inset: inset;
}
.focus-visible\\:ring-\\[\\#324ECF\\]\\/40:focus-visible{
  --tw-ring-color: rgb(50 78 207 / 0.4);
}
.focus-visible\\:ring-\\[\\#4361EE\\]\\/40:focus-visible{
  --tw-ring-color: rgb(67 97 238 / 0.4);
}
.focus-visible\\:ring-\\[\\#6575FE\\]\\/40:focus-visible{
  --tw-ring-color: rgb(101 117 254 / 0.4);
}
.focus-visible\\:ring-dash-accent:focus-visible{
  --tw-ring-color: var(--dash-accent);
}
.focus-visible\\:ring-dash-accentSoft:focus-visible{
  --tw-ring-color: var(--dash-accent-soft);
}
.focus-visible\\:ring-dash-dangerSoft:focus-visible{
  --tw-ring-color: var(--dash-danger-soft);
}
.focus-visible\\:ring-destructive\\/40:focus-visible{
  --tw-ring-color: hsl(from var(--destructive) h s l / 0.4);
}
.focus-visible\\:ring-primary:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(from var(--primary) h s l / var(--tw-ring-opacity));
}
.focus-visible\\:ring-primary\\/40:focus-visible{
  --tw-ring-color: hsl(from var(--primary) h s l / 0.4);
}
.focus-visible\\:ring-white:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.focus-visible\\:ring-white\\/60:focus-visible{
  --tw-ring-color: rgb(255 255 255 / 0.6);
}
.focus-visible\\:ring-white\\/80:focus-visible{
  --tw-ring-color: rgb(255 255 255 / 0.8);
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-\\[\\#01162A\\]:focus-visible{
  --tw-ring-offset-color: #01162A;
}
.active\\:translate-y-0:active{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.active\\:bg-dash-accentHover:active{
  background-color: var(--dash-accent-hover);
}
.active\\:bg-dash-hover:active{
  background-color: var(--dash-hover);
}
.disabled\\:\\!cursor-not-allowed:disabled{
  cursor: not-allowed !important;
}
.disabled\\:cursor-default:disabled{
  cursor: default;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:cursor-progress:disabled{
  cursor: progress;
}
.disabled\\:cursor-wait:disabled{
  cursor: wait;
}
.disabled\\:border:disabled{
  border-width: 1px;
}
.disabled\\:border-border:disabled{
  --tw-border-opacity: 1;
  border-color: hsl(from var(--border) h s l / var(--tw-border-opacity));
}
.disabled\\:bg-muted:disabled{
  --tw-bg-opacity: 1;
  background-color: hsl(from var(--muted) h s l / var(--tw-bg-opacity));
}
.disabled\\:text-gray-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.disabled\\:text-muted-foreground:disabled{
  --tw-text-opacity: 1;
  color: hsl(from var(--muted-foreground) h s l / var(--tw-text-opacity));
}
.disabled\\:no-underline:disabled{
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}
.disabled\\:\\!opacity-50:disabled{
  opacity: 0.5 !important;
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}
.disabled\\:opacity-80:disabled{
  opacity: 0.8;
}
.disabled\\:shadow-none:disabled{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:hover\\:bg-\\[\\#324ECF\\]\\/10:hover:disabled{
  background-color: rgb(50 78 207 / 0.1);
}
.disabled\\:hover\\:bg-dash-accent:hover:disabled{
  background-color: var(--dash-accent);
}
.disabled\\:hover\\:bg-dash-active:hover:disabled{
  background-color: var(--dash-active);
}
.disabled\\:hover\\:bg-dash-surface:hover:disabled{
  background-color: var(--dash-surface);
}
.disabled\\:hover\\:bg-transparent:hover:disabled{
  background-color: transparent;
}
.disabled\\:hover\\:text-\\[\\#324ECF\\]:hover:disabled{
  --tw-text-opacity: 1;
  color: rgb(50 78 207 / var(--tw-text-opacity));
}
.disabled\\:hover\\:text-dash-text2:hover:disabled{
  color: var(--dash-text2);
}
.disabled\\:hover\\:text-green-600:hover:disabled{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.disabled\\:active\\:scale-100:active:disabled{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:block{
  display: block;
}
.group:hover .group-hover\\:w-9{
  width: 2.25rem;
}
.group:hover .group-hover\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-\\[400\\%\\]{
  --tw-translate-x: 400%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-dash-accentSoft{
  background-color: var(--dash-accent-soft);
}
.group:hover .group-hover\\:bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.group:hover .group-hover\\:text-dash-accentInk{
  color: var(--dash-accent-ink);
}
.group:hover .group-hover\\:text-dash-text{
  color: var(--dash-text);
}
.group:hover .group-hover\\:text-dash-text2{
  color: var(--dash-text2);
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:bg-dash-accent{
  background-color: var(--dash-accent);
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-\\[3px\\]{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-dash-accentSoft{
  --tw-ring-color: var(--dash-accent-soft);
}
@media (prefers-reduced-motion: no-preference){

  @keyframes ping{

    75%, 100%{
      transform: scale(2);
      opacity: 0;
    }
  }

  .motion-safe\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  @keyframes pulse{

    50%{
      opacity: .5;
    }
  }

  .motion-safe\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
}
@media (prefers-reduced-motion: reduce){

  .motion-reduce\\:hidden{
    display: none;
  }

  .motion-reduce\\:animate-none{
    animation: none;
  }

  .motion-reduce\\:transition-none{
    transition-property: none;
  }
}
@media not all and (min-width: 1024px){

  .max-aiLg\\:hidden{
    display: none;
  }

  .max-aiLg\\:min-w-\\[1000px\\]{
    min-width: 1000px;
  }

  .max-aiLg\\:flex-col{
    flex-direction: column;
  }

  .max-aiLg\\:overflow-x-auto{
    overflow-x: auto;
  }

  .max-aiLg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .max-aiLg\\:border-t{
    border-top-width: 1px;
  }
}
@media not all and (min-width: 768px){

  .max-aiMd\\:order-2{
    order: 2;
  }

  .max-aiMd\\:order-3{
    order: 3;
  }

  .max-aiMd\\:ml-0{
    margin-left: 0px;
  }

  .max-aiMd\\:ml-auto{
    margin-left: auto;
  }

  .max-aiMd\\:flex{
    display: flex;
  }

  .max-aiMd\\:hidden{
    display: none;
  }

  .max-aiMd\\:aspect-\\[16\\/8\\]{
    aspect-ratio: 16/8;
  }

  .max-aiMd\\:h-10{
    height: 2.5rem;
  }

  .max-aiMd\\:h-11{
    height: 2.75rem;
  }

  .max-aiMd\\:h-12{
    height: 3rem;
  }

  .max-aiMd\\:h-2{
    height: 0.5rem;
  }

  .max-aiMd\\:h-4{
    height: 1rem;
  }

  .max-aiMd\\:h-9{
    height: 2.25rem;
  }

  .max-aiMd\\:max-h-none{
    max-height: none;
  }

  .max-aiMd\\:min-h-\\[44px\\]{
    min-height: 44px;
  }

  .max-aiMd\\:min-h-\\[48px\\]{
    min-height: 48px;
  }

  .max-aiMd\\:w-10{
    width: 2.5rem;
  }

  .max-aiMd\\:w-11{
    width: 2.75rem;
  }

  .max-aiMd\\:w-12{
    width: 3rem;
  }

  .max-aiMd\\:w-16{
    width: 4rem;
  }

  .max-aiMd\\:w-9{
    width: 2.25rem;
  }

  .max-aiMd\\:w-\\[100px\\]{
    width: 100px;
  }

  .max-aiMd\\:w-\\[min\\(16rem\\2c 85vw\\)\\]{
    width: min(16rem,85vw);
  }

  .max-aiMd\\:w-full{
    width: 100%;
  }

  .max-aiMd\\:min-w-\\[320px\\]{
    min-width: 320px;
  }

  .max-aiMd\\:min-w-\\[520px\\]{
    min-width: 520px;
  }

  .max-aiMd\\:min-w-\\[640px\\]{
    min-width: 640px;
  }

  .max-aiMd\\:max-w-none{
    max-width: none;
  }

  .max-aiMd\\:flex-1{
    flex: 1 1 0%;
  }

  .max-aiMd\\:shrink-0{
    flex-shrink: 0;
  }

  .max-aiMd\\:basis-full{
    flex-basis: 100%;
  }

  .max-aiMd\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .max-aiMd\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .max-aiMd\\:flex-wrap{
    flex-wrap: wrap;
  }

  .max-aiMd\\:items-center{
    align-items: center;
  }

  .max-aiMd\\:justify-center{
    justify-content: center;
  }

  .max-aiMd\\:gap-2{
    gap: 0.5rem;
  }

  .max-aiMd\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .max-aiMd\\:gap-3{
    gap: 0.75rem;
  }

  .max-aiMd\\:overflow-x-auto{
    overflow-x: auto;
  }

  .max-aiMd\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .max-aiMd\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .max-aiMd\\:p-0{
    padding: 0px;
  }

  .max-aiMd\\:p-3{
    padding: 0.75rem;
  }

  .max-aiMd\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .max-aiMd\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .max-aiMd\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-aiMd\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-aiMd\\:pb-\\[84px\\]{
    padding-bottom: 84px;
  }

  .max-aiMd\\:pb-\\[96px\\]{
    padding-bottom: 96px;
  }

  .max-aiMd\\:pl-3{
    padding-left: 0.75rem;
  }

  .max-aiMd\\:pr-1{
    padding-right: 0.25rem;
  }

  .max-aiMd\\:shadow-2xl{
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media not all and (min-width: 640px){

  .max-aiSm\\:left-4{
    left: 1rem;
  }

  .max-aiSm\\:right-4{
    right: 1rem;
  }

  .max-aiSm\\:order-first{
    order: -9999;
  }

  .max-aiSm\\:m-4{
    margin: 1rem;
  }

  .max-aiSm\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .max-aiSm\\:ml-0{
    margin-left: 0px;
  }

  .max-aiSm\\:mt-4{
    margin-top: 1rem;
  }

  .max-aiSm\\:flex{
    display: flex;
  }

  .max-aiSm\\:hidden{
    display: none;
  }

  .max-aiSm\\:h-10{
    height: 2.5rem;
  }

  .max-aiSm\\:h-11{
    height: 2.75rem;
  }

  .max-aiSm\\:h-12{
    height: 3rem;
  }

  .max-aiSm\\:h-14{
    height: 3.5rem;
  }

  .max-aiSm\\:h-5{
    height: 1.25rem;
  }

  .max-aiSm\\:min-h-\\[240px\\]{
    min-height: 240px;
  }

  .max-aiSm\\:min-h-\\[280px\\]{
    min-height: 280px;
  }

  .max-aiSm\\:min-h-\\[44px\\]{
    min-height: 44px;
  }

  .max-aiSm\\:w-11{
    width: 2.75rem;
  }

  .max-aiSm\\:w-12{
    width: 3rem;
  }

  .max-aiSm\\:w-5{
    width: 1.25rem;
  }

  .max-aiSm\\:w-\\[76px\\]{
    width: 76px;
  }

  .max-aiSm\\:w-\\[80px\\]{
    width: 80px;
  }

  .max-aiSm\\:w-\\[min\\(15rem\\2c calc\\(100vw-2rem\\)\\)\\]{
    width: min(15rem,calc(100vw - 2rem));
  }

  .max-aiSm\\:w-full{
    width: 100%;
  }

  .max-aiSm\\:min-w-0{
    min-width: 0px;
  }

  .max-aiSm\\:flex-1{
    flex: 1 1 0%;
  }

  .max-aiSm\\:basis-full{
    flex-basis: 100%;
  }

  .max-aiSm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .max-aiSm\\:flex-col{
    flex-direction: column;
  }

  .max-aiSm\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .max-aiSm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .max-aiSm\\:items-start{
    align-items: flex-start;
  }

  .max-aiSm\\:items-center{
    align-items: center;
  }

  .max-aiSm\\:items-stretch{
    align-items: stretch;
  }

  .max-aiSm\\:justify-center{
    justify-content: center;
  }

  .max-aiSm\\:justify-between{
    justify-content: space-between;
  }

  .max-aiSm\\:justify-stretch{
    justify-content: stretch;
  }

  .max-aiSm\\:gap-1{
    gap: 0.25rem;
  }

  .max-aiSm\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .max-aiSm\\:gap-3{
    gap: 0.75rem;
  }

  .max-aiSm\\:gap-4{
    gap: 1rem;
  }

  .max-aiSm\\:gap-x-4{
    column-gap: 1rem;
  }

  .max-aiSm\\:gap-y-1{
    row-gap: 0.25rem;
  }

  .max-aiSm\\:gap-y-1\\.5{
    row-gap: 0.375rem;
  }

  .max-aiSm\\:self-stretch{
    align-self: stretch;
  }

  .max-aiSm\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .max-aiSm\\:p-3{
    padding: 0.75rem;
  }

  .max-aiSm\\:p-4{
    padding: 1rem;
  }

  .max-aiSm\\:p-6{
    padding: 1.5rem;
  }

  .max-aiSm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-aiSm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .max-aiSm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .max-aiSm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-aiSm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .max-aiSm\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .max-aiSm\\:pb-2\\.5{
    padding-bottom: 0.625rem;
  }

  .max-aiSm\\:pl-1{
    padding-left: 0.25rem;
  }

  .max-aiSm\\:pl-4{
    padding-left: 1rem;
  }

  .max-aiSm\\:pr-1{
    padding-right: 0.25rem;
  }

  .max-aiSm\\:pt-3{
    padding-top: 0.75rem;
  }

  .max-aiSm\\:pt-4{
    padding-top: 1rem;
  }

  .max-aiSm\\:text-center{
    text-align: center;
  }

  .max-aiSm\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .max-aiSm\\:text-\\[15px\\]{
    font-size: 15px;
  }
}
@media (min-width: 640px){

  .aiSm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .aiSm\\:mb-4{
    margin-bottom: 1rem;
  }

  .aiSm\\:ml-2{
    margin-left: 0.5rem;
  }

  .aiSm\\:ml-4{
    margin-left: 1rem;
  }

  .aiSm\\:mr-4{
    margin-right: 1rem;
  }

  .aiSm\\:mr-auto{
    margin-right: auto;
  }

  .aiSm\\:\\!block{
    display: block !important;
  }

  .aiSm\\:block{
    display: block;
  }

  .aiSm\\:\\!inline-block{
    display: inline-block !important;
  }

  .aiSm\\:inline{
    display: inline;
  }

  .aiSm\\:flex{
    display: flex;
  }

  .aiSm\\:inline-flex{
    display: inline-flex;
  }

  .aiSm\\:hidden{
    display: none;
  }

  .aiSm\\:aspect-video{
    aspect-ratio: 16 / 9;
  }

  .aiSm\\:h-10{
    height: 2.5rem;
  }

  .aiSm\\:h-20{
    height: 5rem;
  }

  .aiSm\\:h-32{
    height: 8rem;
  }

  .aiSm\\:h-6{
    height: 1.5rem;
  }

  .aiSm\\:h-8{
    height: 2rem;
  }

  .aiSm\\:h-9{
    height: 2.25rem;
  }

  .aiSm\\:h-\\[26px\\]{
    height: 26px;
  }

  .aiSm\\:w-10{
    width: 2.5rem;
  }

  .aiSm\\:w-20{
    width: 5rem;
  }

  .aiSm\\:w-32{
    width: 8rem;
  }

  .aiSm\\:w-48{
    width: 12rem;
  }

  .aiSm\\:w-52{
    width: 13rem;
  }

  .aiSm\\:w-72{
    width: 18rem;
  }

  .aiSm\\:w-\\[440px\\]{
    width: 440px;
  }

  .aiSm\\:w-\\[560px\\]{
    width: 560px;
  }

  .aiSm\\:w-auto{
    width: auto;
  }

  .aiSm\\:min-w-\\[320px\\]{
    min-width: 320px;
  }

  .aiSm\\:max-w-xs{
    max-width: 20rem;
  }

  .aiSm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .aiSm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .aiSm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .aiSm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .aiSm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 208px\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,208px);
  }

  .aiSm\\:flex-row{
    flex-direction: row;
  }

  .aiSm\\:items-center{
    align-items: center;
  }

  .aiSm\\:justify-end{
    justify-content: flex-end;
  }

  .aiSm\\:justify-between{
    justify-content: space-between;
  }

  .aiSm\\:gap-1{
    gap: 0.25rem;
  }

  .aiSm\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .aiSm\\:gap-2{
    gap: 0.5rem;
  }

  .aiSm\\:gap-3{
    gap: 0.75rem;
  }

  .aiSm\\:gap-4{
    gap: 1rem;
  }

  .aiSm\\:self-start{
    align-self: flex-start;
  }

  .aiSm\\:rounded-2xl{
    border-radius: 1rem;
  }

  .aiSm\\:border-l{
    border-left-width: 1px;
  }

  .aiSm\\:border-t-0{
    border-top-width: 0px;
  }

  .aiSm\\:p-4{
    padding: 1rem;
  }

  .aiSm\\:p-5{
    padding: 1.25rem;
  }

  .aiSm\\:p-6{
    padding: 1.5rem;
  }

  .aiSm\\:p-7{
    padding: 1.75rem;
  }

  .aiSm\\:p-8{
    padding: 2rem;
  }

  .aiSm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .aiSm\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .aiSm\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .aiSm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .aiSm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .aiSm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .aiSm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .aiSm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .aiSm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .aiSm\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .aiSm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .aiSm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .aiSm\\:pl-4{
    padding-left: 1rem;
  }

  .aiSm\\:pl-\\[130px\\]{
    padding-left: 130px;
  }

  .aiSm\\:pt-14{
    padding-top: 3.5rem;
  }

  .aiSm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .aiSm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .aiSm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .aiSm\\:text-\\[21px\\]{
    font-size: 21px;
  }

  .aiSm\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .aiSm\\:text-\\[26px\\]{
    font-size: 26px;
  }

  .aiSm\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .aiSm\\:text-\\[42px\\]{
    font-size: 42px;
  }

  .aiSm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .aiSm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .aiSm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .aiSm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .aiSm\\:leading-9{
    line-height: 2.25rem;
  }

  @media not all and (min-width: 1024px){

    .aiSm\\:max-aiLg\\:col-span-2{
      grid-column: span 2 / span 2;
    }
  }
}
@media (min-width: 768px){

  .aiMd\\:visible{
    visibility: visible;
  }

  .aiMd\\:static{
    position: static;
  }

  .aiMd\\:left-0{
    left: 0px;
  }

  .aiMd\\:left-auto{
    left: auto;
  }

  .aiMd\\:right-0{
    right: 0px;
  }

  .aiMd\\:right-auto{
    right: auto;
  }

  .aiMd\\:z-auto{
    z-index: auto;
  }

  .aiMd\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .aiMd\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .aiMd\\:block{
    display: block;
  }

  .aiMd\\:inline{
    display: inline;
  }

  .aiMd\\:flex{
    display: flex;
  }

  .aiMd\\:inline-flex{
    display: inline-flex;
  }

  .aiMd\\:hidden{
    display: none;
  }

  .aiMd\\:h-12{
    height: 3rem;
  }

  .aiMd\\:h-8{
    height: 2rem;
  }

  .aiMd\\:min-h-\\[320px\\]{
    min-height: 320px;
  }

  .aiMd\\:min-h-\\[460px\\]{
    min-height: 460px;
  }

  .aiMd\\:w-16{
    width: 4rem;
  }

  .aiMd\\:w-40{
    width: 10rem;
  }

  .aiMd\\:w-72{
    width: 18rem;
  }

  .aiMd\\:w-auto{
    width: auto;
  }

  .aiMd\\:min-w-\\[196px\\]{
    min-width: 196px;
  }

  .aiMd\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .aiMd\\:max-w-\\[160px\\]{
    max-width: 160px;
  }

  .aiMd\\:flex-1{
    flex: 1 1 0%;
  }

  .aiMd\\:flex-initial{
    flex: 0 1 auto;
  }

  .aiMd\\:flex-shrink{
    flex-shrink: 1;
  }

  .aiMd\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .aiMd\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .aiMd\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .aiMd\\:grid-cols-\\[220px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 220px minmax(0,1fr);
  }

  .aiMd\\:grid-cols-\\[96px_minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 130px\\)_auto\\]{
    grid-template-columns: 96px minmax(0,1fr) minmax(0,130px) auto;
  }

  .aiMd\\:grid-cols-\\[minmax\\(0\\2c 0\\.9fr\\)_minmax\\(0\\2c 1\\.1fr\\)\\]{
    grid-template-columns: minmax(0,0.9fr) minmax(0,1.1fr);
  }

  .aiMd\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)\\2c 180px\\2c 64px\\2c 112px\\2c 20px\\]{
    grid-template-columns: minmax(0,1fr) 180px 64px 112px 20px;
  }

  .aiMd\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.4fr\\)_auto_auto\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,1.4fr) auto auto;
  }

  .aiMd\\:flex-row{
    flex-direction: row;
  }

  .aiMd\\:items-start{
    align-items: flex-start;
  }

  .aiMd\\:items-stretch{
    align-items: stretch;
  }

  .aiMd\\:justify-start{
    justify-content: flex-start;
  }

  .aiMd\\:gap-2{
    gap: 0.5rem;
  }

  .aiMd\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .aiMd\\:gap-3{
    gap: 0.75rem;
  }

  .aiMd\\:gap-4{
    gap: 1rem;
  }

  .aiMd\\:gap-8{
    gap: 2rem;
  }

  .aiMd\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .aiMd\\:overflow-hidden{
    overflow: hidden;
  }

  .aiMd\\:overflow-visible{
    overflow: visible;
  }

  .aiMd\\:border-b-0{
    border-bottom-width: 0px;
  }

  .aiMd\\:border-l{
    border-left-width: 1px;
  }

  .aiMd\\:border-r{
    border-right-width: 1px;
  }

  .aiMd\\:border-r-0{
    border-right-width: 0px;
  }

  .aiMd\\:border-t-0{
    border-top-width: 0px;
  }

  .aiMd\\:border-border{
    --tw-border-opacity: 1;
    border-color: hsl(from var(--border) h s l / var(--tw-border-opacity));
  }

  .aiMd\\:bg-transparent{
    background-color: transparent;
  }

  .aiMd\\:p-5{
    padding: 1.25rem;
  }

  .aiMd\\:p-6{
    padding: 1.5rem;
  }

  .aiMd\\:p-8{
    padding: 2rem;
  }

  .aiMd\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .aiMd\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .aiMd\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .aiMd\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .aiMd\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .aiMd\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .aiMd\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .aiMd\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .aiMd\\:pl-8{
    padding-left: 2rem;
  }

  .aiMd\\:pt-1{
    padding-top: 0.25rem;
  }

  .aiMd\\:pt-4{
    padding-top: 1rem;
  }

  .aiMd\\:pt-6{
    padding-top: 1.5rem;
  }

  .aiMd\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .aiMd\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .aiMd\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .aiMd\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .aiMd\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .aiMd\\:leading-6{
    line-height: 1.5rem;
  }
}
@media (min-width: 1024px){

  .aiLg\\:absolute{
    position: absolute;
  }

  .aiLg\\:sticky{
    position: -webkit-sticky;
    position: sticky;
  }

  .aiLg\\:inset-0{
    inset: 0px;
  }

  .aiLg\\:bottom-4{
    bottom: 1rem;
  }

  .aiLg\\:top-0{
    top: 0px;
  }

  .aiLg\\:top-6{
    top: 1.5rem;
  }

  .aiLg\\:z-10{
    z-index: 10;
  }

  .aiLg\\:order-none{
    order: 0;
  }

  .aiLg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .aiLg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .aiLg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .aiLg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .aiLg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .aiLg\\:col-start-3{
    grid-column-start: 3;
  }

  .aiLg\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .aiLg\\:row-start-1{
    grid-row-start: 1;
  }

  .aiLg\\:mt-4{
    margin-top: 1rem;
  }

  .aiLg\\:flex{
    display: flex;
  }

  .aiLg\\:hidden{
    display: none;
  }

  .aiLg\\:aspect-auto{
    aspect-ratio: auto;
  }

  .aiLg\\:min-h-\\[300px\\]{
    min-height: 300px;
  }

  .aiLg\\:w-\\[320px\\]{
    width: 320px;
  }

  .aiLg\\:w-\\[360px\\]{
    width: 360px;
  }

  .aiLg\\:w-auto{
    width: auto;
  }

  .aiLg\\:flex-1{
    flex: 1 1 0%;
  }

  .aiLg\\:columns-2{
    columns: 2;
  }

  .aiLg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .aiLg\\:grid-cols-\\[1\\.3fr_1fr\\]{
    grid-template-columns: 1.3fr 1fr;
  }

  .aiLg\\:grid-cols-\\[260px\\2c minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 260px minmax(0,1fr);
  }

  .aiLg\\:grid-cols-\\[260px_minmax\\(0\\2c 1fr\\)_280px\\]{
    grid-template-columns: 260px minmax(0,1fr) 280px;
  }

  .aiLg\\:grid-cols-\\[280px\\2c minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 280px minmax(0,1fr);
  }

  .aiLg\\:grid-cols-\\[340px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 340px minmax(0,1fr);
  }

  .aiLg\\:grid-cols-\\[minmax\\(0\\2c 1\\.15fr\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1.15fr) minmax(0,1fr);
  }

  .aiLg\\:grid-cols-\\[minmax\\(0\\2c 1\\.6fr\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1.6fr) minmax(0,1fr);
  }

  .aiLg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)\\2c auto\\2c minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1fr) auto minmax(0,1fr);
  }

  .aiLg\\:grid-cols-\\[minmax\\(0\\2c 340px\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,340px) minmax(0,1fr);
  }

  .aiLg\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .aiLg\\:flex-row{
    flex-direction: row;
  }

  .aiLg\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .aiLg\\:items-start{
    align-items: flex-start;
  }

  .aiLg\\:items-end{
    align-items: flex-end;
  }

  .aiLg\\:items-center{
    align-items: center;
  }

  .aiLg\\:justify-between{
    justify-content: space-between;
  }

  .aiLg\\:gap-0{
    gap: 0px;
  }

  .aiLg\\:gap-16{
    gap: 4rem;
  }

  .aiLg\\:gap-8{
    gap: 2rem;
  }

  .aiLg\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .aiLg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .aiLg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .aiLg\\:border-l{
    border-left-width: 1px;
  }

  .aiLg\\:border-l-0{
    border-left-width: 0px;
  }

  .aiLg\\:border-r{
    border-right-width: 1px;
  }

  .aiLg\\:border-t{
    border-top-width: 1px;
  }

  .aiLg\\:border-t-0{
    border-top-width: 0px;
  }

  .aiLg\\:border-dash-border{
    border-color: var(--dash-border);
  }

  .aiLg\\:p-5{
    padding: 1.25rem;
  }

  .aiLg\\:p-6{
    padding: 1.5rem;
  }

  .aiLg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .aiLg\\:pl-0{
    padding-left: 0px;
  }

  .aiLg\\:pt-4{
    padding-top: 1rem;
  }

  .aiLg\\:text-right{
    text-align: right;
  }

  .aiLg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .aiLg\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .aiLg\\:text-\\[14px\\]{
    font-size: 14px;
  }

  .aiLg\\:text-\\[16px\\]{
    font-size: 16px;
  }

  .aiLg\\:opacity-0{
    opacity: 0;
  }

  .aiLg\\:opacity-60{
    opacity: 0.6;
  }

  .aiLg\\:shadow-\\[0_-8px_30px_-12px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.18\\)\\2c var\\(--shadow-soft\\)\\]{
    --tw-shadow-color: 0 -8px 30px -12px rgba(15,23,42,0.18),var(--shadow-soft);
    --tw-shadow: var(--tw-shadow-colored);
  }

  .group:focus-within .aiLg\\:group-focus-within\\:opacity-100{
    opacity: 1;
  }

  .group:hover .aiLg\\:group-hover\\:opacity-100{
    opacity: 1;
  }
}
@media (min-width: 1280px){

  .aiXl\\:inline{
    display: inline;
  }

  .aiXl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .aiXl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .aiXl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .aiXl\\:grid-cols-\\[300px_minmax\\(0\\2c 1fr\\)_340px\\]{
    grid-template-columns: 300px minmax(0,1fr) 340px;
  }

  .aiXl\\:p-5{
    padding: 1.25rem;
  }

  .aiXl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .aiXl\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .min-\\[1280px\\]\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .min-\\[1280px\\]\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .min-\\[1280px\\]\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_360px\\]{
    grid-template-columns: minmax(0,1fr) 360px;
  }

  .min-\\[1280px\\]\\:items-start{
    align-items: flex-start;
  }
}
@media (prefers-color-scheme: dark){

  .dark\\:border-zinc-600\\/60{
    border-color: rgb(82 82 91 / 0.6);
  }

  .dark\\:bg-zinc-800{
    --tw-bg-opacity: 1;
    background-color: rgb(39 39 42 / var(--tw-bg-opacity));
  }

  .dark\\:text-zinc-200{
    --tw-text-opacity: 1;
    color: rgb(228 228 231 / var(--tw-text-opacity));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;+EAQ+E;AAE/E,8FAA8F;AAE9F,wFAAwF;AAExF,4DAA4D;;AAG5D;EACE,4CAA4C;;EAE5C;;;;6EAI2E;EAC3E,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,qEAAqE;EACrE,sDAAsD;EACtD,sDAAsD;EACtD,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;;yEAEyE;AACzE;EACE,iGAAiG;AACnG;;AAEA;;uBAEuB;AACvB;EACE;;IAEE,uBAAuB;EACzB;AACF;;AAEA;;;4EAG4E;AAC5E;;EAEE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;AACA;;EAEE,aAAa,EAAE,+BAA+B;AAChD;;AAEA;2EAC2E;AAC3E;;EAEE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;AACA;;EAEE,aAAa,EAAE,+BAA+B;AAChD;;AAEA,qBAAc;;AAAd;;;IAAA,sBAAc;IAAd,SAAc;IAAd,UAAc;IAAd,eAAc,EAAd,kCAAc;IAAd,mBAAc,EAAd,mCAAc;EAAA;;AAAd,kCAAc;;AAAd;;IAAA,gBAAc;IAAd,8BAAc;IAAd,mCAAc;EAAA;;AAAd;IAAA,iBAAc;IAAd,uBAAc;IAAd,6BAAc;EAAA;;AAAd,oCAAc;;AAAd;;IAAA,eAAc;IAAd,cAAc;EAAA;;AAAd,yCAAc;;AAAd;;;;IAAA,aAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,yBAAc;EAAA;;AAAd,uBAAc;;AAAd;;IAAA,gBAAc;EAAA;;AAAd,qBAAc;;AAAd;IAAA,wBAAc;IAAd,cAAc;EAAA;;AAAd,sCAAc;;AAAd;;;IAAA,qBAAc,EAAd,wCAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AA8hBlB;IACE,2DAA2D;IAC3D,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;EACvB;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,4BAA4B;IAC5B,mFAAmF;IACnF,2EAA2E;EAC7E;AACA;yCACuC;AACvC;IACE,mCAAmC;EACrC;AACA;IACE,2CAA2C;EAC7C;AACA,kEAAkE;AAClE;IACE,0CAA0C;IAC1C,2CAA2C;EAC7C;AAzjBF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;UAAnB;AAAmB;AAAnB;EAAA,0CAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,4EAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,wKAAmB;EAAnB,wJAAmB;EAAnB,gNAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uGAAmB;EAAnB,+FAAmB;EAAnB,8HAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA4JjB;IACE,qBAAqB;IACrB,oCAAoC;EACtC;AAEA;IACE,UAAU;IACV,WAAW;EACb;AAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;AAEA;IACE,yBAAyB;EAC3B;AA7KF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gEAAmB;UAAnB;AAAmB;;AAkEnB;qFACqF;AACrF;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA,eAAe,kBAAkB,EAAE;AACnC,eAAe,iBAAiB,EAAE;AAClC,eAAe,eAAe,EAAE;AAChC,cAAc,gBAAgB,EAAE;AAChC;eACe,wBAAwB,EAAE,qBAAqB,EAAE;AAChE,eAAe,gBAAgB,EAAE;AACjC,eAAe,mBAAmB,EAAE;AACpC,eAAe,iBAAiB,EAAE;AAClC,cAAc,cAAc,EAAE,0BAA0B,EAAE;AAC1D,mBAAmB,gBAAgB,EAAE;;AAErC;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;MACM,2BAA2B;EAC/B,cAAc;;AAEhB;;AAEA;EACE,uBAAuB;AACzB;AACA;;;;GAIG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;AAClC;AACA,4BAA4B;;AAE5B,uCAAuC;AACvC;EACE,mCAAmC,EAAE,gBAAgB;EACrD,gCAAgC,EAAE,YAAY;AAChD;;AAEA;EACE,wBAAwB,EAAE,0BAA0B;EACpD,mBAAmB;EACnB,oBAAoB;AACtB;;AAuBA,uBAAuB;AACvB;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA,iFAAiF;AACjF;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,4CAA4C,EAAE;EACpD,OAAO,uCAAuC,EAAE;AAClD;AACA;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,6CAA6C,EAAE;EACrD,OAAO,uCAAuC,EAAE;AAClD;AACA;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,4CAA4C,EAAE;EACpD,OAAO,uCAAuC,EAAE;AAClD;AACA,8EAA8E;AAC9E;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA,sBAAsB,wCAAwC,EAAE;AAChE;EACE,sBAAsB,eAAe,EAAE;AACzC;;AAEA,iFAAiF;AACjF;EACE,WAAW,sBAAsB,EAAE;EACnC,MAAM,oBAAoB,EAAE;AAC9B;AACA,mBAAmB,4CAA4C,EAAE,wBAAwB,EAAE;AAC3F;EACE,mBAAmB,eAAe,EAAE,sBAAsB,EAAE;AAC9D;;AAEA,iFAAiF;AACjF;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;AACA,oBAAoB,6DAA6D,EAAE;AACnF;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;AACA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;AACA;EACE,oBAAoB,eAAe,EAAE;EACrC,0BAA0B,eAAe,EAAE;AAC7C;;AAEA,SAAS,+CAA+C,EAAE;AAC1D,SAAS,+CAA+C,EAAE;AAC1D,SAAS,+CAA+C,EAAE;AAC1D;EACE;;;IAGE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE;KACG;AACL;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;AACpD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;AACpD;;AAEA,2BAC4B,2BAA2B;EAIrD,wBAAwB,EAAE,iBAAiB;AAH7C;;AAMA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB,EAAE,YAAY;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;gFAMgF;AAChF;EACE,sEAAsE;EACtE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB,EAAE,6CAA6C;EACtE,oBAAoB;EACpB,0BAA0B;EAC1B,wCAAwC;EACxC,+CAA+C;EAC/C,mDAAmD;EACnD,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,wCAAwC;EACxC,4EAA4E;EAC5E,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,4CAA4C;EAC5C,sBAAsB;EACtB,0BAA0B;EAC1B,4CAA4C;EAC5C,oBAAoB;EACpB,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;EACvB,2BAA2B;EAC3B,6CAA6C;EAC7C,uBAAuB;EACvB,2BAA2B;EAC3B,6CAA6C;EAC7C,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,WAAW;EACX,qCAAqC;EACrC,oBAAoB;;EAEpB;;;;;;;;;;;;;qDAamD;EACnD,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB;;;;yDAIuD;EACvD,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;;EAE7B,cAAc;EACd,iDAAiD;EACjD,sDAAsD;EACtD,0CAA0C;;EAE1C;0EACwE;EACxE,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;;EAE/B,4CAA4C;EAC5C,kBAAkB,EAAE,kDAAkD;AACxE;;AAEA;EACE,wFAAwF;EACxF,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB,EAAE,mDAAmD;EAC1E,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;EAC1B,2CAA2C;EAC3C,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2CAA2C;EAC3C,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,6CAA6C;EAC7C,2BAA2B;EAC3B,6CAA6C;EAC7C,0BAA0B;EAC1B,0CAA0C;EAC1C,mCAAmC;EACnC,oBAAoB;;EAEpB;4DAC0D;EAC1D,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,2FAA2F;EAC3F,0DAA0D;EAC1D,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,uEAAuE;EACvE,mBAAmB,EAAE,gDAAgD;AACvE;;AAEA;EACE,uEAAuE;EACvE,mBAAmB;AACrB;;;AAGA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;;;;+EAI+E;AAgC/E;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kEAAkE;AACpE;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,+EAA+E;AAC/E;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,mCAAmC;EACnC;;;;uBAIqB;AACvB;AACA;;8DAE8D;AAC9D;EACE;IACE,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;EAClB;AACF;AACA,qEAAqE;AACrE;;EAEE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;0CAG0C;AAC1C;EACE,iFAAiF;EACjF,0BAA0B;AAC5B;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,0BAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;AACA;;iCAEiC;AACjC;;EAEE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;qEACqE;AACrE;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yDAAwQ;EACxQ,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,6CAA6C;AAC/C;AACA,qEAAqE;AACrE;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;AACA,2BAA2B,iBAAiB,EAAE;AAC9C,2BAA2B,iBAAiB,EAAE;AAC9C;2BAC2B,cAAc,EAAE;AAC3C,uCAAuC,aAAa,EAAE;AACtD;;EAEE,oBAAoB;AACtB;AACA,2BAA2B,gBAAgB,EAAE;AAC7C,2BAA2B,mBAAmB,EAAE;AAChD,+CAA+C,qBAAqB,EAAE;AACtE,gDAAgD,wBAAwB,EAAE;AAC1E,+BAA+B,aAAa,EAAE;AAC9C,gCAAgC,iBAAiB,EAAE;AACnD,mCAAmC,wBAAwB,EAAE;AAC7D;0BAC0B,uBAAuB,EAAE,gBAAgB,EAAE;AACrE,0BAA0B,6BAA6B,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AACjH,iDAAiD;AACjD;EACE,iBAAiB;AACnB;AACA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,qBAAqB;AACvB;;AAEA;;;;iFAIiF;;AAEjF;kFACkF;AAClF;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;;;EAIE,kCAAkC;AACpC;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,yCAAyC;EAC3C;AACF;;AAEA;;;0EAG0E;AAC1E;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;;AAEA,+EAA+E;AAC/E;EACE;;;;;;yDAMuD;EACvD;;aAEW;EACX,4CAA4C;AAC9C;AACA;EACE;IACE;;SAEK;EACP;EACA;IACE;;SAEK;EACP;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;4DAE4D;AAC5D;;;EAGE,8CAA8C;EAC9C,yCAAyC;EACzC,6BAA6B;EAC7B,sBAAsB;EACtB,yDAAiD;EAAjD,iDAAiD;AACnD;AACA;;;EAGE,0DAA0D;AAC5D;;AAEA;;;;;;;;;mFASmF;;AAEnF;;;2EAG2E;AAC3E;EACE;;;IAGE,gBAAgB;EAClB;;EAEA,2EAA2E;EAC3E;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;gEAC8D;EAC9D;IACE,yBAAyB;EAC3B;;EAEA;;8DAE4D;EAC5D;IACE,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA,kEAAkE;EAClE;IACE,aAAa;IACb,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;;;oDAIoD;AACpD;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uEAAuE;IACvE,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;EAC7B;EACA;IACE,qBAAqB;IACrB,+BAA+B;EACjC;AACF;AAxkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,8BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,+BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,iCAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,uCAykCA;UAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,gDAykCA;EAzkCA,2DAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,+EAykCA;EAzkCA,mGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,6EAykCA;EAzkCA,iGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,0CAykCA;EAzkCA,uDAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,yCAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,iCAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,iCAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,yCAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,8BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,yCAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,8BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,qBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,iBAykCA;EAzkCA,iBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kCAykCA;UAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA,8BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,oBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,eAykCA;EAzkCA,eAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,qBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,0BAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,yBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,sBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA,kBAykCA;EAzkCA,kBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,yBAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;EAAA,2GAykCA;EAzkCA,yGAykCA;EAzkCA;AAykCA;AAzkCA;EAAA;AAykCA;AAzkCA;;EAAA;;IAAA;MAAA,mBAykCA;MAzkCA;IAykCA;EAAA;;EAzkCA;IAAA;EAykCA;;EAzkCA;;IAAA;MAAA;IAykCA;EAAA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,gDAykCA;IAzkCA,6DAykCA;IAzkCA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,gBAykCA;IAzkCA,uBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,sBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,eAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;;IAAA;MAAA;IAykCA;EAAA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,uBAykCA;IAzkCA,4DAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,sBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,iBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA,wBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,wBAykCA;IAzkCA,0DAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,mBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,2EAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA,qBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;;EAzkCA;IAAA;EAykCA;AAAA;AAzkCA;;EAAA;IAAA;EAykCA;;EAzkCA;IAAA,kBAykCA;IAzkCA;EAykCA;;EAzkCA;IAAA,oBAykCA;IAzkCA;EAykCA;AAAA","sourcesContent":["/* ──────────────────────────────────────────────────────────────────────────\n   PLATFORM FONT — SINGLE SOURCE OF TRUTH\n   To change the platform font everywhere, edit the two lines below:\n     1. the @import (or @font-face) that LOADS the font, and\n     2. the --app-font-family value that SELECTS it.\n   Every font utility (Tailwind `font-sans`/`font-inter`/`font-nunito-sans`/\n   `font-fontFamily`) and the theme token (`fontFamily` in theme.constants.ts)\n   resolve to var(--app-font-family) — so this one variable controls the whole app.\n   ────────────────────────────────────────────────────────────────────────── */\n@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');\n/* Inter + Space Grotesk (display) — used only inside the recruiter dashboard shell (.vdash) */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap');\n/* Plus Jakarta Sans — used only inside the marketing landing page shell (.ai-landing) */\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,500&display=swap');\n/* Geist Pixel — used only for the landing page hero title */\n@import url('https://fonts.googleapis.com/css2?family=Geist+Pixel&display=swap');\n\n:root {\n  --app-font-family: 'Nunito Sans', sans-serif;\n\n  /* ── Candidate-journey design tokens (R8) ─────────────────────────────────\n     Semantic, shadcn-style names so the reference (Lovable) markup ports\n     near-verbatim. Everything is anchored on the brand blue (#324ECF) so the\n     whole journey reads as one product. Change a value here once to restyle\n     every journey screen. ──────────────────────────────────────────────── */\n  --background: #ffffff;\n  --foreground: #0f1729;\n  --card: #ffffff;\n  --card-foreground: #0f1729;\n  --muted: #f1f4f9;\n  --muted-foreground: #5b6577;\n  --primary: #324ecf;\n  --primary-foreground: #ffffff;\n  --accent: #eef1fd;\n  --accent-foreground: #2740a8;\n  --destructive: #e5484d;\n  --destructive-foreground: #ffffff;\n  --border: #e4e8f0;\n  --gradient-primary: linear-gradient(135deg, #324ecf 0%, #5b6ef0 100%);\n  --shadow-card: 0 20px 45px -22px rgba(15, 23, 42, 0.3);\n  --shadow-soft: 0 8px 24px -12px rgba(15, 23, 42, 0.14);\n  /* dark surface for the camera/video preview area */\n  --video-surface: oklch(0.18 0.05 265);\n}\n\n/* Marketing landing page shell — overriding --app-font-family here re-points every\n   font-inter/font-sans/font-nunito-sans utility already used across the landing\n   sections to Plus Jakarta Sans, without touching the rest of the app. */\n.ai-landing {\n  --app-font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Custom cursor replaces the native pointer on the landing page — force it off\n   on every descendant so button/link `cursor-pointer` classes can't bring the\n   native arrow back. */\n@media (pointer: fine) {\n  .ai-landing,\n  .ai-landing * {\n    cursor: none !important;\n  }\n}\n\n/* Hide the scrollbar only where the landing page is mounted — scoped via\n   :has() so the rest of the app (dashboard, etc.) keeps its normal scrollbar.\n   The app's actual scrolling element is the shell's `overflow-y-auto` panel\n   (see App.tsx), not <body>, but both are covered in case of other hosts. */\nbody:has(.ai-landing),\n.overflow-y-auto:has(.ai-landing) {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* legacy Edge/IE */\n}\nbody:has(.ai-landing)::-webkit-scrollbar,\n.overflow-y-auto:has(.ai-landing)::-webkit-scrollbar {\n  display: none; /* Chrome / Safari / new Edge */\n}\n\n/* Same intent, applied imperatively (see landing-page.tsx) so it doesn't\n   depend on :has() support or on knowing which ancestor owns the scroll. */\nhtml.ai-landing-scrollbar-hide,\nbody.ai-landing-scrollbar-hide {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* legacy Edge/IE */\n}\nhtml.ai-landing-scrollbar-hide::-webkit-scrollbar,\nbody.ai-landing-scrollbar-hide::-webkit-scrollbar {\n  display: none; /* Chrome / Safari / new Edge */\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  /* Box sizing reset */\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border-width: 0; /* Explicitly reset border width */\n    border-style: solid; /* Ensure consistent border style */\n  }\n\n  /* Basic document-level defaults */\n  html,\n  body {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    font-family: var(--app-font-family);\n  }\n\n  body {\n    min-height: 100vh;\n    scroll-behavior: smooth;\n    text-rendering: optimizeSpeed;\n  }\n\n  /* Make images easier to work with */\n  img,\n  picture {\n    max-width: 100%;\n    display: block;\n  }\n\n  /* Inherit fonts for inputs and buttons */\n  input,\n  button,\n  textarea,\n  select {\n    font: inherit;\n    /* border: inherit;  */\n    border-color: inherit;\n    background-color: inherit;\n  }\n\n  /* Remove list styles */\n  ul,\n  ol {\n    list-style: none;\n  }\n\n  /* Anchor tag reset */\n  a {\n    text-decoration: inherit;\n    color: inherit;\n  }\n\n  /* Only lighten existing div borders */\n  div,\n  input,\n  textarea {\n    border-color: inherit; /* Prevent forcing borders on all divs */\n  }\n}\n\n/* Candidate-facing JD preview content (R4). The global base reset strips list\n   styles + margins, so restore readable typography for recruiter-authored JD HTML. */\n.jd-prose {\n  color: #334155;\n  font-size: 0.9rem;\n  line-height: 1.7;\n}\n.jd-prose h1,\n.jd-prose h2,\n.jd-prose h3 {\n  font-weight: 700;\n  color: #0f1729;\n  margin: 1rem 0 0.5rem;\n  line-height: 1.3;\n}\n.jd-prose h1 { font-size: 1.25rem; }\n.jd-prose h2 { font-size: 1.1rem; }\n.jd-prose h3 { font-size: 1rem; }\n.jd-prose p { margin: 0.5rem 0; }\n.jd-prose ul,\n.jd-prose ol { margin: 0.5rem 0 0.75rem; padding-left: 1.25rem; }\n.jd-prose ul { list-style: disc; }\n.jd-prose ol { list-style: decimal; }\n.jd-prose li { margin: 0.25rem 0; }\n.jd-prose a { color: #324ecf; text-decoration: underline; }\n.jd-prose strong { font-weight: 700; }\n\n.job-description-container .ql-editor {\n  height: 200px;\n  overflow: auto;\n}\n\n.ql-editor {\n      height: calc(100vh - 290px);\n  overflow: auto;\n \n}\n\n#read-mode-quill .ql-editor {\n  height: auto !important;\n}\n/* .MuiInputBase-root {\n  background-color: rgb(232, 235, 249) !important;\n  border-radius: 12px !important;\n  height: 50px !important;\n} */\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: #e7e7f0 !important;\n}\n\n.MuiFormLabel-root {\n  color: #1C1A4A !important; /* Dark navy label */\n  font-weight: 500;\n}\n\n.Mui-focused .MuiFormLabel-root {\n  color: #1C1A4A !important; /* Stay dark navy */\n}\n\n.MuiInputBase-input::placeholder {\n  color: #676780 !important;\n  opacity: 1;\n}\n\n.MuiFormHelperText-root {\n  margin-left: 0 !important;\n  color: #D60000 !important;\n  font-size: 12px;\n}\n\n/* Error State */\n.Mui-error .MuiOutlinedInput-notchedOutline {\n  border-color: #C92525 !important;\n}\n/* Custom Scrollbar Styles */\n\n/* Hide scrollbar but allow scrolling */\n.scrollbar-hide {\n  -ms-overflow-style: none !important; /* IE and Edge */\n  scrollbar-width: none !important; /* Firefox */\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none !important; /* Chrome, Safari, Opera */\n  width: 0 !important;\n  height: 0 !important;\n}\n\n@layer utilities {\n  .thin-scrollbar {\n    scrollbar-width: thin;\n    scrollbar-color: #c4c4c4 transparent;\n  }\n\n  .thin-scrollbar::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  .thin-scrollbar::-webkit-scrollbar-thumb {\n    background-color: #c4c4c4;\n    border-radius: 9999px;\n  }\n\n  .thin-scrollbar::-webkit-scrollbar-thumb:hover {\n    background-color: #a3a3a3;\n  }\n}\n\n/* Css Ripple effect  */\n@keyframes ripple {\n  0% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n.animate-ripple {\n  animation: ripple 1.5s infinite;\n}\n\n.delay-300 {\n  animation-delay: 0.3s;\n}\n.delay-600 {\n  animation-delay: 0.6s;\n}\n\n/* ── Aurora background orbs (status screens) — slow living drift ───────────── */\n@keyframes orb-float-a {\n  0% { transform: translate(0px, 0px) scale(1); }\n  50% { transform: translate(60px, 50px) scale(1.15); }\n  100% { transform: translate(0px, 0px) scale(1); }\n}\n@keyframes orb-float-b {\n  0% { transform: translate(0px, 0px) scale(1); }\n  50% { transform: translate(-70px, -40px) scale(0.9); }\n  100% { transform: translate(0px, 0px) scale(1); }\n}\n@keyframes orb-float-c {\n  0% { transform: translate(0px, 0px) scale(1); }\n  50% { transform: translate(40px, -60px) scale(1.2); }\n  100% { transform: translate(0px, 0px) scale(1); }\n}\n/* Staggered entrance for guideline cards/list items (subtle gamified feel). */\n@keyframes fade-in-up {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n.animate-fade-in-up { animation: fade-in-up 0.5s ease-out both; }\n@media (prefers-reduced-motion: reduce) {\n  .animate-fade-in-up { animation: none; }\n}\n\n/* AI interviewer voice bars — only rendered while the interviewer is speaking. */\n@keyframes ai-wave {\n  0%, 100% { transform: scaleY(0.3); }\n  50% { transform: scaleY(1); }\n}\n.animate-ai-wave { animation: ai-wave 0.9s ease-in-out infinite; transform-origin: center; }\n@media (prefers-reduced-motion: reduce) {\n  .animate-ai-wave { animation: none; transform: scaleY(0.6); }\n}\n\n/* ── Toast notifications — slide-in + auto-dismiss progress bar ────────────── */\n@keyframes toast-in {\n  from { opacity: 0; transform: translateX(18px) scale(0.98); }\n  to { opacity: 1; transform: translateX(0) scale(1); }\n}\n.animate-toast-in { animation: toast-in 0.28s cubic-bezier(0.22, 1, 0.36, 1) both; }\n@keyframes toast-progress {\n  from { transform: scaleX(1); }\n  to { transform: scaleX(0); }\n}\n.animate-toast-progress {\n  transform-origin: left;\n  animation: toast-progress 5s linear forwards;\n}\n@media (prefers-reduced-motion: reduce) {\n  .animate-toast-in { animation: none; }\n  .animate-toast-progress { animation: none; }\n}\n\n.orb-a { animation: orb-float-a 18s ease-in-out infinite; }\n.orb-b { animation: orb-float-b 24s ease-in-out infinite; }\n.orb-c { animation: orb-float-c 21s ease-in-out infinite; }\n@media (prefers-reduced-motion: reduce) {\n  .orb-a,\n  .orb-b,\n  .orb-c {\n    animation: none;\n  }\n}\n\n/* Desktop view */\n@media (min-width: 899px) {\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n}\n\n/* Mobile view */\n@media (max-width: 900px) {\n  /* ::-webkit-scrollbar {\n  } */\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #acacac;\n  border-radius: 10px;\n  border: 2px solid transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #acacac;\n}\n\n.horizontal-scroll-container {\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scroll-behavior: smooth;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n}\n\n.scroll-container {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n}\n\n.react-datepicker-popper {\n  z-index: 9999 !important; /* Ensure on top of modal */\n}\n\n.react-datepicker-popper {\n  z-index: 9999 !important; /* above modals */\n}\n\n.react-datepicker__input-container input {\n  padding: 0.5rem 2rem;\n}\n\n.react-datepicker__header {\n  background-color: #f9fafb; /* gray-50 */\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__time-list-item--selected {\n  background-color: #6575FE !important;\n  color: white !important;\n}\n\n.react-datepicker__day--keyboard-selected {\n  background-color: #e0e7ff;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   VRITI DASHBOARD DESIGN SYSTEM (.vdash)\n   Scoped token set for the recruiter dashboard shell only. Dark is the default\n   theme; `.vdash-light` overrides every token, so components style once with\n   Tailwind `dash-*` utilities (see tailwind.config.js) and get both themes.\n   8px spacing system · Inter · small radii · soft borders · subtle elevation.\n   ═══════════════════════════════════════════════════════════════════════════ */\n.vdash {\n  /* surfaces — soft layered dark (no pure black, low-strain contrast) */\n  --dash-bg: #0a0c10;\n  --dash-bg2: #0d0f14;\n  --dash-surface: #171b22; /* elevated panels, inputs, nested surfaces */\n  --dash-card: #12151b;\n  --dash-card-hover: #171b22;\n  --dash-border: rgba(255, 255, 255, 0.07);\n  --dash-border-strong: rgba(255, 255, 255, 0.13);\n  /* ink — off-white, comfortable for long sessions */\n  --dash-text: #f3f4f6;\n  --dash-text2: #b6bec9;\n  --dash-muted: #8a93a3;\n  /* interaction */\n  --dash-hover: rgba(255, 255, 255, 0.05);\n  --dash-active: rgba(255, 255, 255, 0.09);\n  /* accents — \"ink\" variants are readable as small text on the card surface */\n  --dash-accent: #3b82f6;\n  --dash-accent-hover: #2563eb;\n  --dash-accent-ink: #60a5fa;\n  --dash-accent-soft: rgba(59, 130, 246, 0.12);\n  --dash-purple: #8b5cf6;\n  --dash-purple-ink: #a78bfa;\n  --dash-purple-soft: rgba(139, 92, 246, 0.12);\n  --dash-cyan: #06b6d4;\n  --dash-cyan-ink: #22d3ee;\n  --dash-cyan-soft: rgba(6, 182, 212, 0.11);\n  --dash-success: #10b981;\n  --dash-success-ink: #34d399;\n  --dash-success-soft: rgba(16, 185, 129, 0.11);\n  --dash-warning: #f59e0b;\n  --dash-warning-ink: #fbbf24;\n  --dash-warning-soft: rgba(245, 158, 11, 0.11);\n  --dash-danger: #ef4444;\n  --dash-danger-ink: #f87171;\n  --dash-danger-soft: rgba(239, 68, 68, 0.11);\n  /* charts */\n  --dash-grid: rgba(182, 190, 201, 0.1);\n  --dash-tick: #8a93a3;\n\n  /* ── Categorical series palette ──────────────────────────────────────\n     Eight fixed slots, ASSIGNED IN ORDER and never cycled — a ninth series\n     folds into \"Other\" rather than reusing slot 1, because a repeated hue\n     makes two different things look like the same thing.\n\n     These are the dark-surface steps; `.vdash-light` re-steps the SAME eight\n     hues for the light surface. Not an automatic flip: a hue readable on\n     #12151b is not readable on #ffffff, and vice versa.\n\n     Validated as a set against this surface (OKLab ΔE, colour-vision\n     simulation): worst adjacent pair separates by ΔE 8.4 under protanopia and\n     19.3 in normal vision, every slot clears 3:1 contrast. The palette this\n     replaced put emerald beside magenta at ΔE 4.9 — indistinguishable to a\n     deuteranope, i.e. two series that read as one. */\n  --dash-series-1: #3987e5;\n  --dash-series-2: #d95926;\n  --dash-series-3: #199e70;\n  --dash-series-4: #c98500;\n  --dash-series-5: #d55181;\n  --dash-series-6: #008300;\n  --dash-series-7: #9085e9;\n  --dash-series-8: #e66767;\n\n  /* ── Interview lifecycle phases ──────────────────────────────────────\n     A FIXED colour per phase, so \"before / during / after\" means the same\n     colour on every chart, card and table in the console. Colour follows the\n     phase, never its rank — a filter that drops a phase must not repaint the\n     survivors. Validated as its own set in both modes. */\n  --dash-phase-pre: #3987e5;\n  --dash-phase-in: #d95926;\n  --dash-phase-post: #199e70;\n  --dash-phase-platform: #9085e9;\n  --dash-phase-unknown: #e66767;\n\n  /* elevation */\n  --dash-shadow-card: 0 1px 2px rgba(0, 0, 0, 0.18);\n  --dash-shadow-pop: 0 8px 24px -10px rgba(0, 0, 0, 0.4);\n  --dash-scrollbar: rgba(138, 147, 163, 0.3);\n\n  /* Hiring funnel: colour carries meaning, not identity (the axis names each bar).\n     Validated with the dataviz palette checks against the card surface. */\n  --dash-funnel-total: #94a3b8;\n  --dash-funnel-pipeline: #3b82f6;\n  --dash-funnel-good: #059669;\n  --dash-funnel-bad: #ef4444;\n  --dash-funnel-dropped: #64748b;\n  --dash-funnel-on-total: #0f172a;\n\n  font-family: 'Inter', var(--app-font-family);\n  color-scheme: dark; /* native date inputs / selects follow the theme */\n}\n\n.vdash.vdash-light {\n  /* Layered so white cards read clearly: off-white frame, cool-grey panel, white cards. */\n  --dash-bg: #e4e9f0;\n  --dash-accent: #4f46e5;\n  --dash-accent-hover: #4338ca;\n  --dash-bg2: #f7f9fc;\n  --dash-surface: #ffffff;\n  --dash-card: #ffffff;\n  --dash-card-hover: #f8fafc;\n  --dash-border: rgba(15, 23, 42, 0.12);\n  --dash-border-strong: rgba(15, 23, 42, 0.2);\n  --dash-text: #0f172a;\n  --dash-text2: #475569;\n  --dash-muted: #526175; /* 5.2:1 on the panel, 6.3:1 on cards (was 2.6:1) */\n  --dash-hover: rgba(15, 23, 42, 0.04);\n  --dash-active: rgba(15, 23, 42, 0.07);\n  --dash-accent-ink: #4f46e5;\n  --dash-accent-soft: rgba(79, 70, 229, 0.09);\n  --dash-funnel-total: #1e293b;\n  --dash-funnel-pipeline: #4f46e5;\n  --dash-funnel-good: #059669;\n  --dash-funnel-bad: #dc2626;\n  --dash-funnel-dropped: #64748b;\n  --dash-funnel-on-total: #ffffff;\n  --dash-purple-ink: #7c3aed;\n  --dash-purple-soft: rgba(139, 92, 246, 0.1);\n  --dash-cyan-ink: #0891b2;\n  --dash-cyan-soft: rgba(6, 182, 212, 0.1);\n  --dash-success-ink: #059669;\n  --dash-success-soft: rgba(16, 185, 129, 0.12);\n  --dash-warning-ink: #b45309;\n  --dash-warning-soft: rgba(245, 158, 11, 0.14);\n  --dash-danger-ink: #dc2626;\n  --dash-danger-soft: rgba(239, 68, 68, 0.1);\n  --dash-grid: rgba(15, 23, 42, 0.07);\n  --dash-tick: #526175;\n\n  /* The same eight hues, re-stepped for the light surface — selected against\n     it, not lightened programmatically from the dark set. */\n  --dash-series-1: #2a78d6;\n  --dash-series-2: #eb6834;\n  --dash-series-3: #1baf7a;\n  --dash-series-4: #eda100;\n  --dash-series-5: #e87ba4;\n  --dash-series-6: #008300;\n  --dash-series-7: #4a3aa7;\n  --dash-series-8: #e34948;\n\n  --dash-phase-pre: #2a78d6;\n  --dash-phase-in: #eb6834;\n  --dash-phase-post: #1baf7a;\n  --dash-phase-platform: #4a3aa7;\n  --dash-phase-unknown: #e34948;\n  --dash-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 6px -2px rgba(15, 23, 42, 0.06);\n  --dash-shadow-pop: 0 12px 32px -8px rgba(15, 23, 42, 0.18);\n  --dash-scrollbar: rgba(100, 116, 139, 0.35);\n  color-scheme: light;\n}\n\n/* Greeting-name gradient: deep Vriti violet on light, lifted violet on dark */\n.vdash {\n  --dash-name-grad: linear-gradient(92deg, #f5f5f5, #9ca3af 55%, #4b5563);\n  --dash-day: #9db1f7; /* calendar day numbers — soft on layered dark */\n}\n\n.vdash.vdash-light {\n  --dash-name-grad: linear-gradient(92deg, #324FCF, #1f3494 55%, #1d295c);\n  --dash-day: #324fcf;\n}\n\n\n.vdash .dash-display {\n  font-family: 'Space Grotesk', 'Inter', var(--app-font-family);\n  letter-spacing: -0.02em;\n}\n\n/* Accessible keyboard focus everywhere inside the dashboard */\n.vdash :focus-visible {\n  outline: 2px solid var(--dash-accent);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* Themed scrollbars inside the dashboard */\n.vdash *::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n.vdash *::-webkit-scrollbar-track {\n  background: transparent;\n}\n.vdash *::-webkit-scrollbar-thumb {\n  background-color: var(--dash-scrollbar);\n  border-radius: 10px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n.vdash * {\n  scrollbar-width: thin;\n  scrollbar-color: var(--dash-scrollbar) transparent;\n}\n\n/* Skeleton loader — one shimmer for every loading state in the app (see\n   components/ui/skeleton). Shape (size, radius) comes from utilities on the\n   element; this only paints the surface, so it sits in the components layer\n   where a `rounded-*` or `h-*` utility still wins. Tokens fall back to neutral\n   values outside a .vdash scope (candidate pages, the pre-theme route gate). */\n@layer components {\n  .dash-skeleton {\n    --skeleton-base: var(--dash-active, rgba(15, 23, 42, 0.07));\n    --skeleton-shine: rgba(255, 255, 255, 0.55);\n    position: relative;\n    overflow: hidden;\n    background: var(--skeleton-base);\n    border-radius: 0.5rem;\n  }\n  .dash-skeleton::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    transform: translateX(-100%);\n    background: linear-gradient(90deg, transparent, var(--skeleton-shine), transparent);\n    animation: dash-shimmer var(--skeleton-duration, 1.6s) ease-in-out infinite;\n  }\n  /* The sweep lightens the surface: white on the light theme, the hover tint\n     on dark (where white would flash). */\n  .vdash .dash-skeleton {\n    --skeleton-shine: var(--dash-hover);\n  }\n  .vdash-light .dash-skeleton {\n    --skeleton-shine: rgba(255, 255, 255, 0.55);\n  }\n  /* On a dark media surface (the video player), lighter on black. */\n  .dash-skeleton.dash-skeleton-inverse {\n    --skeleton-base: rgba(255, 255, 255, 0.08);\n    --skeleton-shine: rgba(255, 255, 255, 0.06);\n  }\n}\n@keyframes dash-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .dash-skeleton::after {\n    animation: none;\n    display: none;\n  }\n}\n\n/* Micro-interaction entrances (150–250ms, subtle) */\n@keyframes dash-fade-up {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes dash-scale-in {\n  from {\n    opacity: 0;\n    transform: scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.vdash .dash-fade-up {\n  animation: dash-fade-up 0.22s ease-out both;\n}\n.vdash .dash-pop {\n  animation: dash-scale-in 0.16s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n@media (prefers-reduced-motion: reduce) {\n  .vdash .dash-fade-up,\n  .vdash .dash-pop {\n    animation: none;\n  }\n}\n\n/* Card primitive — border + hover elevation shared by every dashboard widget */\n.vdash .dash-card {\n  background: var(--dash-card);\n  border: 1px solid var(--dash-border);\n  border-radius: 12px;\n  box-shadow: var(--dash-shadow-card);\n  transition:\n    border-color 0.2s ease,\n    background-color 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.2s ease;\n}\n/* App shell — from aiMd up the main column is a rounded panel inset on the\n   sidebar's canvas, so sidebar and content read as one surface instead of two\n   boxes split by a rule. Phones keep the full-bleed layout. */\n@media (min-width: 768px) {\n  .vdash .dash-shell-panel {\n    margin: 8px 8px 8px 0;\n    border: 1px solid var(--dash-border);\n    border-radius: 16px;\n    box-shadow: var(--dash-shadow-card);\n    overflow: hidden;\n  }\n}\n/* Wordmark — white-letter version on the dark theme, navy on light */\n.vdash .dash-wordmark__dark,\n.vdash.vdash-light .dash-wordmark__light {\n  display: none;\n}\n.vdash.vdash-light .dash-wordmark__dark {\n  display: block;\n}\n/* Org chart — nested <ul>/<li> with elbow connectors drawn by pseudo-elements.\n   ul::before drops from the manager; each li's ::before/::after are the two\n   halves of the horizontal rail, and ::after (or ::before on the last child)\n   carries the drop into the child card. */\n.vdash .org-tree-canvas {\n  background-image: radial-gradient(var(--dash-border-strong) 1px, transparent 1px);\n  background-size: 18px 18px;\n}\n.vdash .org-tree {\n  --org-line: var(--dash-border-strong);\n  --org-gap: 28px;\n  width: max-content;\n  min-width: 100%;\n  padding: 28px 24px 40px;\n}\n.vdash .org-tree ul {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  padding: var(--org-gap) 0 0;\n  list-style: none;\n}\n.vdash .org-tree > ul {\n  padding-top: 0;\n}\n.vdash .org-tree li {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: var(--org-gap) 10px 0;\n}\n.vdash .org-tree li::before,\n.vdash .org-tree li::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 50%;\n  width: 50%;\n  height: var(--org-gap);\n  border-top: 2px solid var(--org-line);\n}\n.vdash .org-tree li::after {\n  right: auto;\n  left: 50%;\n  border-left: 2px solid var(--org-line);\n}\n.vdash .org-tree li:only-child {\n  padding-top: 0;\n}\n.vdash .org-tree li:only-child::before,\n.vdash .org-tree li:only-child::after,\n.vdash .org-tree > ul > li::before,\n.vdash .org-tree > ul > li::after {\n  display: none;\n}\n.vdash .org-tree > ul > li {\n  padding-top: 0;\n}\n.vdash .org-tree li:first-child::before,\n.vdash .org-tree li:last-child::after {\n  border: 0 none;\n}\n.vdash .org-tree li:last-child::before {\n  border-right: 2px solid var(--org-line);\n  border-radius: 0 10px 0 0;\n}\n.vdash .org-tree li:first-child::after {\n  border-radius: 10px 0 0 0;\n}\n.vdash .org-tree ul ul::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  height: var(--org-gap);\n  border-left: 2px solid var(--org-line);\n}\n.vdash .org-tree__node {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.vdash .org-tree__toggle {\n  position: relative;\n  z-index: 1;\n  margin-top: -12px;\n}\n/* Modal backdrops carry `.vdash` for theming, which the light-mode aurora rule\n   above would repaint as an opaque page — hiding the app behind the dialog.\n   Keep them a translucent dim. */\n.vdash.vdash-light.dash-overlay,\n.vdash.dash-overlay {\n  background-color: rgba(15, 23, 42, 0.45);\n  background-image: none;\n}\n\n/* Native selects: one consistent field look with a drawn chevron. Selects that\n   already draw their own (class `appearance-none`) are left alone. */\n.vdash select:not([multiple]):not(.appearance-none) {\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' viewBox='0 0 24 24'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.65rem center;\n  background-size: 16px 16px;\n  padding-right: 2.25rem;\n  cursor: pointer;\n}\n.vdash select:not([multiple]):not(.appearance-none):focus {\n  outline: none;\n  border-color: var(--dash-accent);\n  box-shadow: 0 0 0 3px var(--dash-accent-soft);\n}\n/* Rendered job-description HTML: real headings, lists and spacing. */\n.vdash .dash-richtext {\n  color: var(--dash-text2);\n  font-size: 14px;\n  line-height: 1.7;\n}\n.vdash .dash-richtext > * + * {\n  margin-top: 0.6em;\n}\n.vdash .dash-richtext h1,\n.vdash .dash-richtext h2,\n.vdash .dash-richtext h3,\n.vdash .dash-richtext h4 {\n  color: var(--dash-text);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  line-height: 1.35;\n  margin-top: 1.4em;\n}\n.vdash .dash-richtext h1 { font-size: 1.35em; }\n.vdash .dash-richtext h2 { font-size: 1.15em; }\n.vdash .dash-richtext h3,\n.vdash .dash-richtext h4 { font-size: 1em; }\n.vdash .dash-richtext > :first-child { margin-top: 0; }\n.vdash .dash-richtext ul,\n.vdash .dash-richtext ol {\n  padding-left: 1.25em;\n}\n.vdash .dash-richtext ul { list-style: disc; }\n.vdash .dash-richtext ol { list-style: decimal; }\n.vdash .dash-richtext li[data-list='bullet'] { list-style-type: disc; }\n.vdash .dash-richtext li[data-list='ordered'] { list-style-type: decimal; }\n.vdash .dash-richtext .ql-ui { display: none; }\n.vdash .dash-richtext li + li { margin-top: 0.3em; }\n.vdash .dash-richtext li::marker { color: var(--dash-muted); }\n.vdash .dash-richtext strong,\n.vdash .dash-richtext b { color: var(--dash-text); font-weight: 600; }\n.vdash .dash-richtext a { color: var(--dash-accent-ink); text-decoration: underline; text-underline-offset: 2px; }\n/* Comfortable reading rhythm for long sessions */\n.vdash {\n  line-height: 1.55;\n}\n.vdash .dash-card-hover:hover {\n  border-color: var(--dash-border-strong);\n  box-shadow: var(--dash-shadow-pop);\n  transform: translateY(-1px);\n}\n\n/* Native date inputs render with theme-appropriate indicator */\n.vdash input[type='date'] {\n  color-scheme: inherit;\n}\n\n/* Light mode: no page-wide gradient. The old blue \"aurora\" painted the shell and\n   the main panel with one fixed wash, which erased the frame → panel → card\n   layering and left white cards floating on a pale haze. Each layer now shows its\n   own token (--dash-bg2 frame, --dash-bg panel, --dash-card cards).\n   Cards are plain white: a sheen toward grey only narrowed the card/panel gap. */\n\n/* JD description (read-mode quill) — compact, columned on wide screens, and\n   token-colored so recruiter-authored inline colors stay readable in dark mode. */\n.vdash .jd-desc-columns .ql-container {\n  font-size: 15px;\n}\n.vdash .jd-desc-columns .ql-editor {\n  padding: 0;\n  line-height: 1.7;\n  color: var(--dash-text2);\n}\n.vdash .jd-desc-columns .ql-editor p {\n  margin: 0 0 0.35rem;\n}\n.vdash .jd-desc-columns .ql-editor,\n.vdash .jd-desc-columns .ql-editor * {\n  color: var(--dash-text2) !important;\n  background: transparent !important;\n}\n.vdash .jd-desc-columns .ql-editor strong,\n.vdash .jd-desc-columns .ql-editor h1,\n.vdash .jd-desc-columns .ql-editor h2,\n.vdash .jd-desc-columns .ql-editor h3 {\n  color: var(--dash-text) !important;\n}\n@media (min-width: 1024px) {\n  .vdash .jd-desc-columns .ql-editor {\n    column-count: 2;\n    column-gap: 3rem;\n    column-rule: 1px solid var(--dash-border);\n  }\n}\n\n/* JD editors (original + AI-generated): the Quill \"snow\" theme paints a stark\n   light (#ccc) border on its toolbar/container that reads as a white box inside\n   the already dash-bordered card. Drop that inner border and theme the toolbar\n   to dash tokens so the editor matches the dashboard in dark and light. */\n.vdash .jd-editor-quill .ql-container.ql-snow {\n  border: none;\n}\n.vdash .jd-editor-quill .ql-toolbar.ql-snow {\n  border: none;\n  border-bottom: 1px solid var(--dash-border);\n}\n.vdash .jd-editor-quill .ql-toolbar.ql-snow .ql-stroke {\n  stroke: var(--dash-text2);\n}\n.vdash .jd-editor-quill .ql-toolbar.ql-snow .ql-fill {\n  fill: var(--dash-text2);\n}\n.vdash .jd-editor-quill .ql-toolbar.ql-snow .ql-picker {\n  color: var(--dash-text2);\n}\n\n/* Striped progress fill — black/gray/#324FCF scheme with slow-moving stripes */\n.vdash .dash-progress-striped {\n  background-image:\n    repeating-linear-gradient(\n      45deg,\n      rgba(255, 255, 255, 0.16) 0 8px,\n      transparent 8px 16px\n    ),\n    linear-gradient(90deg, #111827, #4b5563 45%, #324fcf);\n  background-size:\n    24px 24px,\n    100% 100%;\n  animation: dash-stripes 1.2s linear infinite;\n}\n@keyframes dash-stripes {\n  from {\n    background-position:\n      0 0,\n      0 0;\n  }\n  to {\n    background-position:\n      24px 0,\n      0 0;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .vdash .dash-progress-striped {\n    animation: none;\n  }\n}\n\n/* Chrome autofill paints its own blue box inside the raw <input>, which breaks\n   rounded fields with end-adornments (login/password eye icon). Repaint it with\n   the field surface instead — scoped to the token system. */\n.vdash input:-webkit-autofill,\n.vdash input:-webkit-autofill:hover,\n.vdash input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #ffffff inset;\n  -webkit-text-fill-color: var(--dash-text);\n  caret-color: var(--dash-text);\n  border-radius: inherit;\n  transition: background-color 9999s ease-in-out 0s;\n}\n.vdash:not(.vdash-light) input:-webkit-autofill,\n.vdash:not(.vdash-light) input:-webkit-autofill:hover,\n.vdash:not(.vdash-light) input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px var(--dash-surface) inset;\n}\n\n/* ══════════════════════════════════════════════════════════════════════════════\n   MOBILE-ONLY LAYOUT HELPERS\n\n   Every rule below lives inside a `max-width` media query AND is gated behind an\n   explicit opt-in class, so desktop CSS (>= 640px / >= 768px) is byte-for-byte\n   unchanged and no component picks these up by accident. Used by the Job\n   Postings board, the Interview Report and the Schedule Interview flow to hit\n   native-app touch ergonomics (48px targets, 16px gutters, 8px rhythm) without\n   duplicating the approved desktop layout.\n   ══════════════════════════════════════════════════════════════════════════════ */\n\n/* `m-touch-form` — opt-in on a form/step wrapper. Grows every real text control\n   inside it to a 48px touch target on phones. Checkbox/radio/file inputs and\n   anything explicitly opted out with `data-no-touch-grow` keep their size, as do\n   the narrow inline numeric fields (percentages) that must stay compact. */\n@media (max-width: 639px) {\n  .m-touch-form input:not([type='checkbox']):not([type='radio']):not([type='file']):not([data-no-touch-grow]),\n  .m-touch-form select:not([data-no-touch-grow]),\n  .m-touch-form textarea:not([data-no-touch-grow]) {\n    min-height: 48px;\n  }\n\n  /* Primary actions inside an opted-in form span the full width on phones. */\n  .m-touch-form button[type='submit']:not([data-no-touch-grow]) {\n    width: 100%;\n    min-height: 48px;\n  }\n\n  /* react-select sets its control height as an inline style, so it reads this var\n     instead of a hard 42px (see utils/dash-select-styles.ts). */\n  .m-touch-form {\n    --dash-select-min-h: 48px;\n  }\n\n  /* react-datepicker renders `withPortal` (a centred sheet). Its default\n     day-grid + time-column is ~330px wide, which overflows a 320px viewport —\n     clamp the sheet and let the time column scroll instead. */\n  .react-datepicker__portal .react-datepicker {\n    max-width: calc(100vw - 24px);\n    font-size: 0.8rem;\n  }\n  .react-datepicker__portal .react-datepicker__time-container,\n  .react-datepicker__portal .react-datepicker__time-container .react-datepicker__time-box {\n    width: 72px;\n  }\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__day-name {\n    width: 1.6rem;\n    line-height: 1.6rem;\n    margin: 0.12rem;\n  }\n\n  /* Quill toolbars wrap instead of clipping their format buttons. */\n  .m-quill-wrap .ql-toolbar.ql-snow {\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 2px;\n  }\n}\n\n/* `m-fullscreen-sheet` — opt-in on `Modal`'s card (see `mobileFullScreen`).\n   Turns a centred dialog into an edge-to-edge sheet on phones/small tablets so\n   long forms get the whole viewport and the on-screen keyboard can never cover\n   a field (the card's own body is the scroll container). Uses `dvh` so the\n   sheet tracks the browser's collapsing toolbars. */\n@media (max-width: 767px) {\n  .m-fullscreen-sheet {\n    max-width: none !important;\n    width: 100% !important;\n    /* vh first as the fallback, dvh second for browsers that support it. */\n    height: 100vh !important;\n    max-height: 100vh !important;\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    border-radius: 0 !important;\n  }\n  .m-fullscreen-backdrop {\n    padding: 0 !important;\n    align-items: stretch !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
